{
  "signup": { "guestTitle": "Rejoignez {{appName}} !" },
  "accessibility": {
    "request": {
      "hideHint": "Masquez ce besoin de votre fil d'actualité"
    },
    "imagePicker": {
      "addImageHint": "Ajoutez une autre photo à votre annonce",
      "removeImageHint": "Retirez cette photo de votre annonce"
    },
    "carousel": {
      "previousSlideHint": "Faites défiler la liste vers la gauche",
      "nextSlideHint": "Faites défiler la liste vers la droite"
    },
    "search": {
      "clearSearchHint": "Effacez le texte de recherche actuel"
    }
  },
  "landing-page": {
    "stepsToComplete": {
      "title": "Complétez votre profil",
      "description": "Donnez confiance aux membres en complétant votre profil...",
      "completedSubtitle": "Vous inspirez confiance aux membres de la communauté",
      "addPicture": "Ajoutez une photo",
      "addBio": "Ajoutez une bio",
      "setInterests": "Définissez vos intérêts",
      "addListings": "Ajoutez ({{count}}/5) objets à prêter"
    },
    "noInterestsTitle": "Personnalisez votre découverte",
    "noInterestsSubtitle": "Choisissez vos centres d'intérêt et recevez des suggestions adaptées à vos intérêts.",
    "requests": {
      "emptyState": {
        "subtitle": "Nous vous préviendrons si vos voisins ont besoin d’aide"
      }
    },
    "subscription": {
      "discovery": "Découverte"
    },
    "unlockFullExperience": {
      "accessibilityLabel": "Débloquer l’expérience complète",
      "title": "Débloquez l’expérience complète !",
      "discount": "-25 %",
      "discountDeadline": "jusqu’au {{date}}"
    },
    "multipleOfferCard": {
      "title": "Avez-vous ces objets ?",
      "desktopSubtitle": "Nous avons trouvé <strong>des objets souvent demandés</strong> que vous seriez susceptible de prêter. Les offres sont déjà créées par nos soins : vous n’avez plus qu’à publier!",
      "subtitle": "Vous pouvez rapidement publier des objets liés au thème de la semaine pour aider vos voisins à les trouver !"
    },
    "upcomingActivity": {
      "donationRoles": {
        "lending": "Don offert",
        "borrowing": "Don reçu"
      },
      "saleRoles": {
        "lending": "Vente",
        "borrowing": "Achat"
      },
      "actions": {
        "completePurchase": "Confirmer la réception auprès de {{name}}",
        "completeSale": "Confirmer la vente à {{name}}",
        "handOff": "Remettre à {{name}}",
        "pickUp": "Récupérer auprès de {{name}}",
        "returnItem": "Retourner à {{name}}",
        "expectReturn": "Retour attendu de {{name}}",
        "confirmReturn": "Confirmer le retour de {{name}}",
        "confirmSale": "Confirmer la vente avec {{name}}"
      }
    },
    "carousel": {
      "previousSlideHint": "Faites défiler la liste vers la gauche",
      "nextSlideHint": "Faites défiler la liste vers la droite"
    },
    "immature": {
      "defricheur": {
        "text": "Il y a peu d'objets dans votre quartier. <strong>Abonnement gratuit aux 5 premier.ère.s</strong> qui publieront un objet.",
        "button": "Publiez une offre"
      },
      "referral": {
        "title": "Aidez-nous à faire grandir la communauté. Invitez <strong>5 personnes</strong> et gagnez <strong>un cadeau d'une valeur de 25 $ !</strong>",
        "button": "Invitez vos voisin·e·s"
      },
      "writeToMayor": {
        "text": "Nous avons rédigé une lettre que vous pouvez directement envoyer. Il vous suffit de remplir le formulaire de demande sur notre site web",
        "textLetter": "Nous avons rédigé une lettre que vous pouvez personnaliser et envoyer au maire de votre ville."
      },
      "socialMedia": {
        "title": "Suivez-nous sur les réseaux",
        "text": "Rejoignez des milliers de partageurs et partageuses de confiance"
      }
    }
  },
  "my-interests": {
    "subtitle": "Sélectionnez vos centres d'intérêt pour personnaliser votre découverte",
    "emptySubtitle": "Touchez un intérêt ci-dessous pour l'ajouter à votre profil"
  },
  "all-listings": {
    "guest": {
      "locationHint": "Indiquez votre position pour voir les objets disponibles près de chez vous.",
      "addressError": "Impossible de trouver cette adresse ou ce code postal.",
      "apply": "Appliquer",
      "bannerCta": "Obtenir l'app",
      "bannerText": "Le moyen le plus rapide pour ajouter du matériel à votre profil.",
      "bannerTitle": "Publiez vos objets en un clin d’œil avec l’application mobile",
      "categories": "Catégories",
      "distance": "Dans un rayon de {{distance}} km",
      "distanceTitle": "Dans un rayon de :",
      "locating": "Recherche de votre position…",
      "locationError": "Impossible d'accéder à votre position. La position par défaut reste sélectionnée.",
      "locationTitle": "Localisation",
      "maximumDistance": "Maximum ({{distance}} km)",
      "mobileBannerTitle": "Ouvrir avec l’application mobile {{appName}}",
      "myPosition": "Ma position",
      "myPositionHint": "Découvrez les offres à proximité",
      "postalCode": "Adresse ou code postal",
      "reset": "Réinitialiser",
      "tags": "Étiquettes"
    },
    "bonificationPrompt": {
      "text_one": "Vous avez <strong>un objet</strong> avec une photo générique ou aucune description. Les objets avec une photo ont plus de chances d'être empruntés!",
      "text": "Vous avez <strong>{{numListings}} objets</strong> avec une photo générique ou aucune description. Les objets avec une photo ont plus de chances d'être empruntés!"
    },
    "pendingBonificationsBanner": {
      "subtitle": "Un emprunteur a proposé des améliorations pour votre annonce."
    },
    "addAddressPrompt": {
      "text": "Au bureau, à l’école, au chalet ou chez vos parents : si vous vous y rendez fréquemment, ça vaut le coup d’élargir votre recherche.",
      "title": "Ajoutez une adresse"
    },
    "banner": {
      "xmas": {
        "text": "Les Fêtes arrivent ! Aidez vos voisin.e.s à trouver ces objets souvent demandés."
      },
      "halloween": {
        "text": "Proposez vos costumes en un clic ☞"
      }
    },
    "createYourNeed": "Ajoutez votre besoin",
    "createYourOffer": "Ajoutez votre offre",
    "disconnected": {
      "text": "Créez votre compte ou connectez-vous pour voir les offres près de chez vous.",
      "buttonCode": "Vous avez un code d'invitation ?"
    },
    "empty": {
      "offer": {
        "firstLine": "Débutez votre aventure ici !",
        "secondLine": "Les membres pourront la voir et vous envoyer une demande pour l'emprunter."
      },
      "request": {
        "firstLine": "Vous ne trouvez pas ?",
        "primaryButtonText": "Publiez un besoin !",
        "secondLine": "Les membres peuvent vous aider à trouver ce que vous cherchez."
      },
      "invite": {
        "firstLine": "Débutez votre aventure ici !",
        "primaryButtonText": "Invitez vos voisins",
        "secondLine": "Invitez des voisins ou publiez une offre dans votre quartier."
      }
    },
    "inviteOthersPrompt": {
      "title": "Aidez-nous à faire grandir la communauté dans votre quartier!",
      "description": "Votre quartier semble immature, c'est-à-dire qu'il y a peu de membres dans les environs mais vous pouvez changer la donne !",
      "ctaButton": "Invitez vos voisin·e·s"
    },
    "postNeedPrompt": {
      "afterResults": {
        "text": "Demandez à votre communauté !\n<strong>1 besoin sur 3</strong> est comblé en moins de <strong>24 heures</strong>."
      },
      "noResults": {
        "text": "Demandez à votre communauté !\n<strong>1 besoin sur 3</strong> est comblé en moins de <strong>24 heures</strong>."
      }
    },
    "searchAssistant": {
      "title": "Nous pouvons chercher pour vous !",
      "body": "Souhaitez-vous que notre assistant intelligent contacte des prêteurs susceptibles d'avoir <strong>{{itemName}}</strong> ?",
      "bodyNote": "Vous pourrez ajuster les détails de la recherche à votre convenance juste après."
    },
    "postOfferPrompt": {
      "third": {
        "title": "Demandez à vos voisins",
        "text": "Les membres ont souvent plus d'objets à prêter que ce qui est affiché. Demandez, on ne sait jamais."
      },
      "first": {
        "text": "Publiez 5 objets et gagnez votre <strong>abonnement annuel</strong> !",
        "title": "Gagnez votre abonnement !"
      },
      "firstAfter": {
        "button": "Invitez vos voisin.e.s",
        "text": "Contribuez à faire grandir cette chaîne de générosité !",
        "title": "Invitez vos voisin.e.s !"
      }
    },
    "promoFreeSub": {
      "defricheur": {
        "text1": "⏳ Dernier jour pour profiter de votre essai gratuit. Publiez des offres pour gagner votre abonnement !",
        "text": "⏳ Plus que {{numDays}} jours pour profiter de votre essai gratuit. Publiez des offres pour gagner votre abonnement !"
      },
      "trial": {
        "text": "⏳ Plus que {{numDays}} jours pour profiter de votre essai gratuit. Découvrez notre offre et obtenez votre abonnement gratuit !",
        "text1": "⏳ Dernier jour pour profiter de votre période d'essai. Obtenez votre abonnement gratuit avec notre offre spéciale !"
      }
    },
    "dismissAccessibilityHint": "Masquez ce besoin de votre fil d'actualité",
    "emptyRequests": {
      "secondTitle": "Rien à afficher pour le moment, soyez le premier à ajouter un besoin!"
    },
    "addPhoneNumberPrompt": {
      "banner": {
        "text": "Ajouter <strong>votre numéro de téléphone</strong> aide les membres à vous contacter plus facilement pour organiser des prêts.",
        "title": "Votre profil est complet à {{percent}}%"
      }
    },
    "peopleSearch": {
      "subtitle": "{{count}} membre trouvé près de vous",
      "subtitle_other": "{{count}} membres trouvés près de vous"
    },
    "levelUpModal": {
      "text": "Vous avez augmenté votre impact en publiant votre première offre. Vous accédez maintenant à un niveau supérieur : <strong>Contributeur</strong>."
    },
    "needLogin": {
      "firstLine": "Débutez votre aventure ici !",
      "secondLine": "Connectez-vous pour voir les objets disponibles dans votre quartier."
    },
    "needsAppUpdateText": "Pour bénéficier des dernières fonctionnalités, vous devez mettre à jour l'application en utilisant l'App Store Apple ou le Google Play Store.",
    "noResults": {
      "secondLine": "Soyez le.la premier.ère à le faire!"
    },
    "quickOffer": {
      "text": "Publiez en 10 secondes !"
    },
    "recommended": {
      "title": "Recommandé pour vous"
    }
  },
  "billboard": {
    "unauthenticatedTitle": "Créez un compte ou connectez-vous",
    "unauthenticatedTitle_2": "pour voir les offres près de chez vous.",
    "invitationCode": "Vous avez un code d'invitation ?"
  },
  "closestListingsModal": {
    "breadcrumb": {
      "first": "Vos intérêts",
      "second": "Votre sélection"
    },
    "title": "Brisez la glace et faites votre premier emprunt !",
    "instructions": "Sélectionnez les catégories qui vous intéressent et nous vous proposerons de belles trouvailles."
  },
  "closestListingsChoose": {
    "instructions": "Choisissez l'objet que vous souhaitez emprunter, nous nous en occupons.",
    "messageToSend": "Bonjour {{name}},\nJe suis intéressé.e par votre offre. Avez-vous des disponibilités prochainement ?",
    "chatToast": "On a salué le prêteur pour vous. Maintenant, proposez des dates d’emprunt !"
  },
  "common": {
    "appDownloadPrompt": {
      "title": "Téléchargez l’application",
      "guest": "Vous aimez ce que vous voyez? Retrouvez Partage Club sur votre téléphone et recevez les nouvelles disponibilités près de chez vous",
      "dateProposal": "Téléchargez l'app pour être averti·e dès que {{firstName}} vous répond",
      "listingPublished": "Téléchargez l'app pour publier des offres / besoins encore plus facilement!",
      "thisMember": "ce membre",
      "qrCodeAccessibilityLabel": "Code QR pour télécharger l’application Partage Club"
    },
    "applicationError": {
      "secondLine": "Voici quelques trucs que vous pouvez essayer :\n\n• Attendez quelques secondes, puis utilisez le bouton 'Réessayer' ci-dessous.\n\n• Fermez l’appli complètement, et relancez-la.\n\n• Allez dans l’écran Profil, et déconnectez-vous, puis reconnectez-vous {{connectHow}}\n\n• Désinstallez l’appli de votre appareil, et réinstallez-la.\n\n• Si rien de tout ça ne vous aide, écrivez-nous ASAP à support@partage.club."
    },
    "expiredLoans": {
      "title": "Avez-vous retourné l'objet emprunté ?",
      "secondParagraph": "Confirmez le retour ou modifiez les dates d'emprunt en cliquant ici."
    },
    "expiredService": {
      "firstParagraph": "<strong>{{firstName}} {{lastName}}</strong> devait vous aider à <strong>{{item}}</strong> le {{date}}.",
      "secondParagraph": "Confirmez que le service a été rendu ou modifiez les dates en cliquant ici."
    },
    "expiredDonation": {
      "firstParagraph": "Vous deviez ramasser <strong>{{item}}</strong> le {{date}} chez <strong>{{firstName}} {{lastName}}</strong>.",
      "secondParagraph": "Confirmez que le ramassage a été fait ou modifiez la date en cliquant ici."
    },
    "expiredSale": {
      "secondParagraph": "Confirmez la vente ou modifiez la date de ramassage en cliquant ici."
    },
    "afterResultsFor": "Vous ne trouvez pas ce que vous cherchez ?",
    "cityRequiredError": "Veuillez entrer une ville.",
    "passwordErrorMatching": "Ce champ doit être le même que votre mot de passe",
    "postalCodeRequiredError": "Veuillez entrer un code postal",
    "streetRequiredError": "Veuillez entrer une adresse",
    "updateAvailable": "Bonjour! Nous avons une mise à jour pour vous 🥳🎉."
  },
  "contact-information": {
    "title": "Votre code postal",
    "prompt": "Ajoutez votre code postal afin de découvrir tout ce que vous pouvez emprunter près de chez vous !",
    "mapMarkerPrompt": "Définissez la localisation de votre domicile en positionnant le marqueur sur la carte.",
    "mapStatsPrompt": "Changez le rayon de recherche pour visualiser le nombre de membres et le nombre d'objets qui sont disponibles à emprunter autour de chez vous."
  },
  "contact-us": {
    "firstParagraph": "Le service aux membres du Partage Club est accessible par courriel et par messagerie. Nous vous répondrons dans les plus brefs délais."
  },
  "choose-sharer-type": {
    "subtitle": "Avec {{appName}},\n vous pensez plus..."
  },
  "favourites": {
    "empty": {
      "filtered": "Aucun favori ne correspond à ce filtre.",
      "firstLine": "Mettez votre première offre en favori !"
    },
    "filters": {
      "all": "Tout"
    }
  },
  "guidelines": {
    "secondParagraphInsured": "<strong>Veiller à remettre les objets empruntés</strong> dans l'état dans lequel ils ont été prêtés. Avec votre abonnement, si un dommage survient aux objets que vous prêtez ou empruntez d'une valeur de 25 $ ou plus, <strong>nous nous engageons à vous dédommager jusqu’à 300 $ par an</strong>. N’hésitez pas à nous contacter via la messagerie de l'app ou par courriel à info@partage.club.",
    "fifthParagraph": "Ne pas utiliser Partage Club pour louer ou vendre des objets."
  },
  "introModal": {
    "codeFullWarning": "Tous les abonnements offerts par {{groupName}} ont été distribués mais vous pouvez toujours profiter d’une offre gratuite. →",
    "titleNewFeature": "Partage Club est responsable !",
    "welcome": {
      "b2b": "<strong>Bienvenue dans le Club !</strong>\nGrâce à {{groupName}}, votre abonnement est gratuit. 🎉Profitez-en pour partager de façon illimitée avec {{withWho}} !",
      "withWho": {
        "education": "les membres de votre communauté",
        "enterprise": "vos collègues et vos voisins",
        "municipal": "vos voisins",
        "municipal_closed": "vos voisins",
        "realestate": "vos voisins"
      },
      "trial": {
        "CAD": "<strong>Votre premier emprunt est gratuit !\n</strong><padding/>Prêter vos objets ?\nGratuit à vie.\n<padding/><smaller>Après votre crédit gratuit, abonnez-vous pour continuer à emprunter :\n<padding/><strong>• 60 $/an</strong>\n<padding/><underline>Aucun paiement sans votre accord.</underline></smaller>",
        "EUR": "<strong>Votre premier emprunt est gratuit !\n</strong><padding/>Prêter vos objets ?\nGratuit à vie.\n<padding/><smaller>Après votre crédit gratuit, abonnez-vous pour continuer à emprunter :\n<padding/><strong>• 72 €/an</strong>\n<padding/><underline>Aucun paiement sans votre accord.</underline></smaller>",
        "USD": "<strong>Votre premier emprunt est gratuit !\n</strong><padding/>Prêter vos objets ?\nGratuit à vie.\n<padding/><smaller>Après votre crédit gratuit, abonnez-vous pour continuer à emprunter :\n<padding/><strong>• 72 USD/an</strong>\n<padding/><underline>Aucun paiement sans votre accord.</underline></smaller>"
      },
      "regular": "<strong>Bienvenue dans le Club !</strong>\nEn tant que membre officiel du Partage Club, votre abonnement vous donne accès à de nouveaux avantages."
    },
    "insurable": {
      "insurance": {
        "trial": "Avec votre abonnement, si un dommage survient aux objets que vous prêtez ou empruntez d'une valeur de 25 $ ou plus, <strong>nous nous engageons à vous dédommager jusqu’à 300 $ par an</strong>.",
        "regular": "Grâce à votre abonnement, si un dommage survient à vos objets d'une valeur de 25 $ ou plus pendant un prêt, <strong>nous nous engageons à vous dédommager jusqu’à 300 $ par an</strong>."
      },
      "zeroOnePercent": "Rassurez-vous, moins de 0,1 % des partages entraînent un dommage. Il est tout à fait normal qu'un objet présente des signes d'usure lorsqu'il est partagé et utilisé par plusieurs !"
    },
    "notInsurable": {
      "savings": "<strong>Emprunter, c’est bien plus économique qu’acheter !</strong> Jetez un œil sur l’application avant d’acheter, vous risquez d’être surpris.e.",
      "community": "<strong>C’est l’occasion parfaite pour faire connaissance avec vos voisin·e·s</strong>, et faire un pas vers un monde durable."
    },
    "referralPromo": "<strong>Référez quelqu’un et obtenez un mois gratuit !</strong>\nChaque nouvelle référence prolonge votre abonnement d’un mois.\n\nExemple : 12 références = 12 mois gratuits.",
    "borrow": "<strong>Vous pouvez maintenant emprunter</strong> parmi un large catalogue d’objets disponibles à deux pas de chez vous.",
    "offreDefricheur": "Il y a peu d'objets dans votre quartier. <strong>Abonnement annuel gratuit aux 5 premier.ère.s</strong> qui publieront un objet.",
    "custom": {
      "support": "<strong>Un bris ? Un souci ? Partage Club vous assure un service aux membres en tout temps.</strong>"
    }
  },
  "insured": {
    "listing": {
      "text": {
        "own": "Avec votre abonnement, vous profitez de la Responsabilité Partage Club en cas de dommage à vos objets."
      }
    },
    "myPlan": {
      "text": "En vous abonnant, vous profitez de la Responsabilité Partage Club si un objet que vous prêtez ou empruntez est endommagé."
    },
    "details": {
      "text": {
        "own": "Avec votre abonnement, si un dommage survient aux objets que vous prêtez ou empruntez d'une valeur de 25 $ ou plus, nous nous engageons à vous dédommager jusqu'à <strong>300 $ par an</strong>.",
        "other": "Avec son abonnement, si un dommage survient aux objets que {{name}} vous prête ou vous emprunte d'une valeur de 25 $ ou plus, nous nous engageons à le/la dédommager jusqu'à <strong>300 $ par an</strong>."
      }
    },
    "landing-page": {
      "text": "Vous êtes protégés en cas de dommages"
    }
  },
  "invite": {
    "details": "Vous avez invité {{numInvited}} personnes.\nPlus vous invitez, plus vous contribuez à faire grandir cette chaîne de générosité !",
    "referralProgram": {
      "title": "Aimez-vous Partage Club ?\n<color>Pour chaque référence</color> nous vous offrons <color>1 mois gratuit !</color>",
      "details": "Chaque fois qu’un ami s’abonne avec votre lien de référencement, vous recevez 1 mois gratuit chez Partage Club.",
      "referrals": {
        "title": "Vos références ! 🎉",
        "subTitle_zero": "Faites votre première référence pour obtenir votre premier mois gratuit !",
        "subTitle_one": "<strong>{{count}} personne</strong> a rejoint Partage Club grâce à <strong>vous</strong> 🥳",
        "subTitle": "<strong>{{count}} personnes</strong> ont rejoint Partage Club grâce à <strong>vous</strong> 🥳",
        "rewardMessage_one": "Grâce à votre référence, vous avez gagné <strong>1 mois d’abonnement gratuit</strong> 😊",
        "rewardMessage": "Grâce à vos références, vous avez gagné <strong>{{count}} mois d’abonnement gratuit</strong> 😊"
      },
      "howItWorks": {
        "step1": "Envoyez votre code d'invitation",
        "step2": "Vos amis s’inscrivent avec votre code",
        "step3": "Recevez votre récompense !"
      },
      "gift": {
        "prefix": "Pour chaque personne référée, vous recevez automatiquement un mois gratuit chez Partage Club."
      },
      "shareYourCode": "Partagez votre code",
      "shareText": "Salut !\n\nJ’utilise Partage Club, une app pour partager des objets du quotidien. C’est super pratique et je suis sûr·e que vous allez aimer. Rejoignez-moi :\n\n{{url}}"
    },
    "referralProgram202506": {
      "title": "Aimez-vous Partage Club ?\n<color>Invitez 5 personnes</color> et nous vous offrons <color>un cadeau d’une valeur de 25 $ !</color>",
      "details": "Chaque fois que 5 de vos amis s’abonnent grâce à votre lien de référencement, vous recevez un cadeau d’une valeur de 25 $.",
      "currentStep": {
        "3": "Vous y êtes presque ! 🔥",
        "5": "🎉 Bravo et merci.\nVous avez gagné votre récompense !"
      },
      "howItWorks": {
        "step1": "Envoyez votre code d'invitation",
        "step2": "Vos amis s'inscrivent avec votre code",
        "step3": "Obtenez votre récompense !"
      },
      "gift": {
        "prefix": "Dès que vous atteignez <strong>5 membres référés</strong>, vous obtenez <strong>25 $</strong> au choix :",
        "gift1": "Carte-cadeau à l’épicerie de votre choix",
        "gift3": "Don à un organisme, fait en votre nom"
      },
      "shareText": "Salut !\n\nJ’utilise Partage Club, une app pour partager des objets du quotidien. C’est super pratique et je suis sûr·e que vous allez aimer. Rejoignez-moi :\n\n{{url}}"
    },
    "shareText": "Salut !\n\nJ’utilise Partage Club, une app pour partager des objets du quotidien. C’est super pratique et je suis sûr·e que vous allez aimer. Rejoignez-moi :\n\n{{url}}",
    "subtitle": "Partagez votre code",
    "title": "Invitez vos voisin.e.s ou vos proches !",
    "referrals": {
      "title": "Vos références ! 🎉",
      "subTitle_zero": "Faites votre première référence en partageant votre code !",
      "subTitle_one": "<strong>{{count}} personne</strong> a rejoint Partage Club grâce à <strong>vous</strong> 🥳",
      "subTitle": "<strong>{{count}} personnes</strong> ont rejoint Partage Club grâce à <strong>vous</strong> 🥳"
    }
  },
  "loans": {
    "services": {
      "borrowing": {
        "empty": {
          "secondLine": "Vos emprunts ou services à recevoir s'afficheront ici."
        }
      },
      "lending": {
        "empty": {
          "secondLine": "Vos prêts ou services à rendre s'afficheront ici."
        }
      }
    },
    "donations": {
      "borrowing": {
        "empty": {
          "secondLine": "Vos emprunts ou dons à recevoir s'afficheront ici."
        }
      },
      "lending": {
        "empty": {
          "secondLine": "Vos prêts ou dons offerts s'afficheront ici."
        }
      }
    },
    "services+donations": {
      "borrowing": {
        "empty": {
          "secondLine": "Vos emprunts, vos services à recevoir et dons à recevoir s'afficheront ici."
        }
      },
      "lending": {
        "empty": {
          "secondLine": "Vos prêts, vos services à rendre et dons offerts s'afficheront ici."
        }
      }
    },
    "services+donations-ro": {
      "borrowing": {
        "empty": {
          "secondLine": "Vos dons à recevoir s'afficheront ici."
        }
      },
      "lending": {
        "empty": {
          "secondLine": "Vos services à rendre s'afficheront ici."
        }
      }
    },
    "borrowing": {
      "empty": {
        "secondLine": "Tous vos emprunts s'afficheront ici."
      }
    },
    "calendar": {
      "emptyRange": {
        "description": "Faites défiler le calendrier ou utilisez les flèches pour voir une autre période."
      }
    },
    "card": {
      "type": {
        "offer": {
          "mine": "Votre offre"
        },
        "request": {
          "mine": "Votre besoin"
        }
      }
    },
    "lending": {
      "empty": {
        "secondLine": "Tous vos prêts s'afficheront ici."
      }
    },
    "past": {
      "empty": {
        "filtered": "Aucun historique ne correspond à ce filtre.",
        "firstLine": "Votre historique de partage est vide"
      },
      "filters": {
        "all": "Tout"
      },
      "savings": {
        "header": {
          "lending": "Économisé par vos voisins grâce à vous"
        }
      }
    }
  },
  "login": {
    "signUpOrLogin": "S’inscrire / Se connecter",
    "title": "Connectez-vous",
    "downloadApp": "Téléchargez l'app!",
    "errors": {
      "incorrect-credentials": "Votre courriel ou mot de passe n'est pas valide."
    }
  },
  "management": {
    "bonificationPrompt": {
      "text": "Certains de vos objets sont disponibles, mais sans photo ou description."
    }
  },
  "my-neighbourhood": {
    "addAddressHelp": "Avoir plus d’un club de quartier (plusieurs adresses) vous permet d’accéder à plus d’offres.",
    "noteBelowMap": "Ajustez votre zone de partage en la déplaçant sur la carte.",
    "radiusDescription": "Votre rayon vous permet de partager vos annonces dans un périmètre limité de votre quartier. Les voisins habitant hors de cette zone ne pourront pas voir vos annonces."
  },
  "my-personal-information": {
    "bioFieldPlaceholder": "Parlez-nous un peu de vous."
  },
  "my-plan": {
    "design": {
      "activeSubscription": "Vous êtes présentement sur un abonnement Partage+.",
      "billingNote": {
        "monthly": "*Vous serez facturé {{price}} / mois à la date de renouvellement. Annulez jusqu’à 24 h avant la date de votre prochain paiement.",
        "yearly": "*Vous serez facturé {{price}} / année à la date de renouvellement. Annulez jusqu’à 24 h avant la date de votre prochain paiement."
      },
      "cancelAnytime": "Annulez à tout moment",
      "cancelAnytimeShort": "Annulez en tout temps",
      "cancelDescription": "Vous pouvez annuler votre abonnement jusqu’à 24 h avant la date de votre prochain paiement. Votre abonnement sera renouvelé automatiquement.",
      "freeBorrowDescription": "Empruntez votre premier objet à vos voisin·e·s gratuitement",
      "invitationCode": "Votre code d’invitation",
      "renewalCancelled": "Vous avez annulé le renouvellement de votre abonnement Partage+.",
      "resubscribe": "Me réabonner",
      "shareReferral": "Rejoignez-moi sur Partage Club : {{url}}",
      "unlimitedLendingDescription": "Publiez des offres et prêtez vos objets à vos voisin·e·s autant de fois que vous le souhaitez",
      "yourBenefits": "Vos avantages"
    },
    "defricheurPlan": {
      "firstParagraph": "Vous avez reçu un abonnement gratuit grâce à l'Offre du Défricheur."
    },
    "giftPlan": {
      "firstParagraph": "Vous avez reçu un abonnement cadeau."
    },
    "offreTrialPlan": {
      "firstParagraph": "Vous avez reçu un abonnement gratuit en publiant 5 offres."
    },
    "planExpired": {
      "title": {
        "trial": "Votre période d’essai gratuite est terminée.",
        "regular": "Votre abonnement a expiré."
      },
      "text": {
        "regular": "Vous pouvez continuer à prêter sans abonnement, mais pour emprunter, vous devez vous abonner.",
        "trial": "Vous pouvez continuer à prêter sans abonnement, mais pour emprunter, vous devez vous abonner."
      }
    },
    "referralPrizePlan": {
      "firstParagraph": "Vous avez reçu un abonnement gratuit d'un an en invitant une personne à s'inscrire."
    },
    "regularPlan": {
      "firstParagraph": "Vous êtes présentement sur un abonnement régulier."
    },
    "regularMonthlyPlan": {
      "firstParagraph": "Vous êtes présentement abonné.e à un plan mensuel."
    },
    "regularYearlyPlan": {
      "firstParagraph": "Vous êtes présentement abonné.e à un plan annuel."
    },
    "stopRecurrenceModal": {
      "text": "Votre prochain paiement ne sera pas prélevé, et le renouvellement automatique sera annulé. Vous pourrez continuer de profiter de votre abonnement jusqu'au {{date}}."
    },
    "trialPlan": {
      "firstParagraph": "Vous avez <strong>1 crédit d’emprunt gratuit</strong>."
    },
    "referralProgram": {
      "title": "Envie de prolonger votre abonnement gratuitement ?",
      "subtitle": "Pour chaque personne référée, vous obtenez automatiquement un mois gratuit au Partage Club."
    },
    "businessPlan": {
      "firstParagraph": {
        "education": "Votre abonnement est offert par {{planName}}.",
        "enterprise": "Votre abonnement est offert par {{planName}}.",
        "generic": "Votre abonnement est offert par {{planName}}.",
        "municipal": "Votre abonnement est offert par {{planName}}.",
        "municipal_closed": "Votre abonnement est offert par {{planName}}.",
        "realestate": "Votre abonnement est offert par {{planName}}."
      }
    },
    "dragonPlan": {
      "firstParagraph": "Vous êtes présentement sur un abonnement pour {{planName}}."
    },
    "extraGroups": "Vos autres Clubs",
    "freeSubText": {
      "defricheur": "Il y a peu d'objets dans votre quartier. <strong>Abonnement annuel gratuit aux 5 premier.ère.s</strong> qui publieront un objet.",
      "trial": "Contribuez à faire grandir le catalogue du <strong>Partage Club</strong> ! Publiez 5 objets et gagnez votre <strong>abonnement annuel</strong> !"
    },
    "modal": {
      "error": {
        "codeLimitReached": "Il n’y a plus d’abonnements disponibles pour ce code d’invitation. Toutefois, vous pouvez toujours essayer l'application durant notre période d'essai gratuite.",
        "forbidden": "Vous n'êtes pas autorisé à utiliser ce code",
        "invalidCode": "Le code que vous avez entré n'est pas valide",
        "missingCode": "Veuillez entrer un code"
      },
      "firstParagraph": "Veuillez entrer le code d'invitation qui vous a été transmis.",
      "title": "Activer votre abonnement"
    }
  },
  "neighbour-profile": {
    "unavailabilityBannerMessage": "Le membre est actuellement indisponible et pourrait ne pas répondre à vos messages.",
    "reportUserPrompt": "Bonjour, je souhaite signaler un utilisateur dont le comportement me semble inapproprié. Pourriez-vous examiner son profil ?\n\nMerci.",
    "reportRatingPrompt": "Bonjour, je souhaite signaler une évaluation que je trouve inappropriée. Pourriez-vous l'examiner ?\n\nMerci.",
    "trust": {
      "trusted": "Je lui fais confiance",
      "info": "Les membres de votre club de confiance peuvent voir les offres que vous choisissez de leur réserver.",
      "commonHeading": "Ces membres de votre club de confiance font confiance à {{name}}",
      "removeMessage": "{{name}} ne verra plus les offres réservées à votre club de confiance.",
      "badge": "Dans votre club de confiance"
    },
    "shares": {
      "lentToYou": "vous a prêté",
      "borrowedFromYou": "vous a emprunté",
      "commonWidget": "Vous avez partagé {{count}} fois avec {{name}} · Dernier {{ago}}"
    },
    "placeHelp": {
      "features": {
        "borrow": {
          "description": "Choisissez et empruntez des objets parmi la sélection proposée par le lieu"
        },
        "frequenting": {
          "title": "Indiquez aux autres membres que vous fréquentez ce lieu",
          "description": "Permet aux membres de voir les lieux de partage que vous fréquentez directement sur votre profil"
        }
      }
    },
    "place": {
      "join": {
        "profileTitle": "Afficher ce lieu sur votre profil public",
        "profileDesc": "Les autres utilisateurs pourront voir que vous fréquentez ce lieu.",
        "offersTitle": "Rendez vos offres disponibles aux membres à proximité du lieu",
        "offersDesc": "Vos offres seront visibles par les membres qui fréquentent ce lieu."
      },
      "leave": {
        "profileDesc": "Ce lieu ne sera plus affiché sur votre profil public.",
        "offersDesc": "Vos offres ne seront plus disponibles pour les membres à proximité de ce lieu."
      }
    },
    "reviews": {
      "pendingPrompt": {
        "title": "Vous avez eu une belle expérience ? Partagez-la !",
        "bodyBorrowingStart": "Évaluez votre emprunt de ",
        "bodyLendingStart": "Évaluez votre prêt de "
      }
    }
  },
  "new": {
    "duplicatesStepper": {
      "text": "Créez des copies additionnelles de cette offre."
    },
    "discardChanges": {
      "description": "Votre annonce n’a pas été publiée. Si vous quittez maintenant, le contenu saisi sera perdu."
    },
    "multiImagePicker": {
      "addImageHint": "Ajoutez une autre photo à votre annonce",
      "removeImageHint": "Retirez cette photo de votre annonce",
      "emptyHint": "Ajoutez jusqu’à {{max}} photos. Les objets avec des photos claires et bien éclairées sont empruntés plus souvent."
    },
    "bulk": {
      "steps": {
        "select": {
          "title": "Ajoutez une photo par objet",
          "subtitle": "Choisissez tous les objets que vous voulez publier dans cette session."
        },
        "confirm": {
          "title": "Confirmez les photos",
          "subtitle": "Vérifiez l’ordre et retirez ce que vous ne voulez pas publier."
        },
        "generating": {
          "title": "Création de vos offres",
          "subtitle": "Un titre et une description sont préparés pour chaque photo."
        },
        "review": {
          "title": "Révisez chaque offre",
          "subtitle": "Vérifiez les détails, puis publiez ou passez chaque offre."
        },
        "complete": {
          "subtitle": "Vos offres publiées apparaissent maintenant comme des annonces normales."
        },
        "visibility": {
          "eyebrow": "Visibilité",
          "title": "Qui peut voir ces offres ?",
          "subtitle": "Choisissez les adresses et les groupes pour toutes les offres créées dans cette session."
        }
      },
      "photoSelection": {
        "reorderHint": "Utilisez les flèches pour réordonner"
      },
      "camera": {
        "limitReached": "Vous avez atteint la limite de {{max}} photos",
        "draftHint": "Prenez vos photos, puis appuyez sur Terminer.",
        "permissionDescription": "Autorisez la caméra pour photographier vos objets, ou ajoutez des photos de votre galerie ci-dessous."
      },
      "review": {
        "generationFailedDescription": "Réessayez cette photo ou passez-la pour l’instant.",
        "saveFailedDescription": "Modifiez le titre ou la description et réessayez.",
        "swipeHint": "← Passer · Publier →",
        "title": "Vos offres à vérifier",
        "editHint": "Vérifiez les détails. Vos modifications seront publiées seulement lorsque vous appuierez sur Publier."
      },
      "errors": {
        "noPhotos": "Ajoutez au moins une photo avant de continuer.",
        "noVisibility": "Choisissez au moins une adresse ou un groupe avant de créer des offres."
      },
      "generation": {
        "uploading": "Envoi de vos photos…",
        "reviewHint": "Rien n’est publié sans votre accord.",
        "preparing": "Vos offres prennent forme…"
      },
      "visibility": {
        "confirm": "Enregistrer la visibilité",
        "privateHint": "Toutes les options de partage sont désactivées. Ces offres seront privées."
      },
      "completion": {
        "published_one": "{{count}} offre créée.",
        "published_other": "{{count}} offres créées."
      }
    },
    "itemInformationSection": {
      "descriptionFieldPlaceholder": {
        "offer": "Ajoutez des détails utiles : dimensions, marque, poids… Plus vous en dites, plus il sera facile pour les membres de comprendre votre offre !",
        "request": "Ajoutez des détails utiles : dimensions, marque, poids… Plus vous en dites, plus il sera facile pour les membres de comprendre votre besoin !"
      },
      "descriptionFieldHelperText": "Plus vous en dites, plus il sera facile pour les membres de comprendre votre offre ou votre besoin !",
      "serviceDescriptionFieldPlaceholder": "Ajoutez des détails utiles pour la compréhension du service demandé. Plus vous en dites, plus il sera facile pour les membres de comprendre votre besoin !",
      "assistant": {
        "knowMore": {
          "text2": "Pour que l'assistant puisse vous aider au mieux, donnez un <strong>maximum de détails</strong> relatifs à l'objet dans la description.",
          "text1": "Notre nouvel assistant intelligent <strong>relie</strong> vos besoins à des <strong>offres pertinentes</strong> et <strong>contacte automatiquement</strong> les membres prêteur·euse·s en se basant sur votre <strong>description</strong> et la <strong>distance souhaitée</strong>."
        },
        "firstCreated": {
          "text1": "Génial, l’assistant intelligent a commencé à rechercher des offres pertinentes! Vous serez <strong>prévenu</strong> quand des prêteur·euse·s potentiel·le·s auront <strong>répondu à votre message</strong>.",
          "text3": "En attendant, <strong>retrouvez</strong> l’assistant intelligent directement dans le <strong>détail de votre besoin</strong>."
        },
        "optOutBanner": {
          "description": "Personnalisez le message envoyé avant la publication"
        }
      }
    },
    "chooseAutomaticMessage": {
      "defaultAutomaticMessage": {
        "greeting": "Salut {{firstName}}! J’ai besoin d’aide et votre offre semble correspondre à mon besoin : \n\n"
      },
      "text1": "Votre message automatique",
      "text2": "Vous pourrez toujours le modifier plus tard",
      "automaticMessageLabel": "✏️ Personnalisez le message qui sera envoyé :"
    },
    "prompt": {
      "type": {
        "title": "Que souhaitez-vous publier ?"
      },
      "serviceRequest": {
        "title": "Sélectionnez une catégorie",
        "missing": {
          "title": "Vous ne trouvez pas ?",
          "text": "Envoyez-nous votre demande et nous évaluerons si elle peut être ajoutée dans la liste prochainement.",
          "chatPrompt": "Bonjour {{name}},\n\nN’hésitez pas à nous <strong>communiquer le besoin de service</strong> que vous aimeriez retrouver dans l’application.\n\nNous le transmettrons à la ville de Beaconsfield qui déterminera si on peut l’ajouter."
        }
      }
    },
    "categorySection": {
      "primary": {
        "subtitle": "Sélectionnez une catégorie"
      }
    },
    "generalSection": {
      "oneOrMany": {
        "many": {
          "subtext": "Publiez plusieurs objets en un clic, sans photo ni réflexion au préalable. C'est simple et rapide !"
        },
        "one": {
          "subtext": "Publiez votre objet en le prenant en photo."
        }
      }
    },
    "locationSection": {
      "addressFieldSubtitle": "Basé sur l'adresse de votre domicile",
      "invisible": "Votre annonce ne sera plus affichée aux autres utilisateurs."
    }
  },
  "notifications": {
    "trustAdded": {
      "message": "Un membre vous a recommandé·e."
    },
    "donationEndsSoonMessage": "Changez la date limite, ou supprimez-le s’il n’est plus nécessaire.",
    "emptyState": "Vous n'avez aucune notification",
    "favouriteReceived": "<strong>{{userName}}</strong> a ajouté votre annonce à ses favoris.",
    "favouriteReceivedOffer": "<strong>{{userName}}</strong> a ajouté votre offre à ses favoris.",
    "favouriteReceivedRequest": "<strong>{{userName}}</strong> a ajouté votre besoin à ses favoris.",
    "introModal": {
      "b2c_paid": {
        "body": "En tant que membre officiel du Partage Club, votre abonnement vous donne accès à de nouveaux avantages."
      },
      "b2b_activated": {
        "body": "Grâce à {{groupName}}, votre abonnement est gratuit."
      },
      "newly_insured": {
        "title": "Partage Club est responsable !",
        "body": "Grâce à votre abonnement, si un dommage survient à vos objets d'une valeur de 25 $ ou plus pendant un prêt, nous nous engageons à vous dédommager jusqu’à 300 $ par an."
      },
      "custom": {
        "support": {
          "body": "Notre équipe est là pour vous aider rapidement."
        }
      },
      "intro": {
        "body": "Découvrez Partage Club !"
      }
    },
    "superChanged": {
      "initialGained": {
        "body": "Vous êtes maintenant Super Partageur.euse."
      },
      "initialLost": {
        "title": "Vous avez perdu votre badge de Super Partageur.euse 😢"
      },
      "initialKept": {
        "body": "Vous conservez votre badge de Super Partageur.euse, même avec les nouveaux critères."
      },
      "gained": {
        "body": "Vous êtes maintenant Super Partageur.euse."
      },
      "lost": {
        "title": "Vous avez perdu votre badge de Super Partageur.euse 😢",
        "body": "Découvrez comment le regagner en un rien de temps."
      }
    },
    "rate": {
      "borrower": {
        "title": "Comment s’est passée votre expérience avec {{lenderName}} ?",
        "message": "Votre avis est important pour nous et pour les autres membres du Partage Club."
      },
      "lender": {
        "title": "Comment s’est passée votre expérience avec {{borrowerName}} ?",
        "message": "Votre avis est important pour nous et pour les autres membres du Partage Club."
      }
    },
    "impactLevel": "Votre niveau actuel: <strong>{{level}}</strong> !",
    "impactLevelCelebration": {
      "sharer1": {
        "message": "🥳 Bravo! Continuez à faire grandir votre impact positif.",
        "title": "Vous êtes passés au niveau <strong>Partageur</strong> !"
      },
      "sharer23": {
        "message": "🎉 Vous êtes à <strong>{{numLeft}}</strong> partages du niveau ultime. Continuez un prêt à la fois !"
      },
      "sharer4": {
        "message": "💪🏻 <strong>Un</strong> partage de plus et vous accéderez au plus haut niveau : <strong>Super Partageur.euse</strong>.",
        "title": "Vous y êtes presque !"
      },
      "superSharer": {
        "message": "Bravo ! À chaque partage, vous grandissez votre impact pour un avenir plus vert. Allez voir votre impact! 💚",
        "title": "Vous êtes un·e <strong>Super Partageur.euse</strong> !"
      }
    },
    "impactLevelExplorerMessage": "Commencez votre expérience au Partage Club. Publiez un objet pour grandir votre impact et passer au niveau suivant.",
    "impactLevelMessage": "Bravo ! Allez voir comment vous pouvez grandir votre impact et faire progresser votre niveau.",
    "newListingPostedSubscribed": "<strong>{{userName}}</strong> ({{distance}}) a publié une offre pour un objet qui pourrait vous intéresser : {{itemName}}",
    "newReferralSubscribed": {
      "receivedPrizeMessage": "Bravo ! 🥳 Vous venez de gagner un abonnement annuel gratuit au Partage Club !",
      "receivedMonthPrizeMessage": "Bravo ! 🥳 Vous venez de gagner un mois gratuit au Partage Club !",
      "referredUserRegisteredMessage": "Vous avez invité {{numInvited}} personnes.\nPlus vous invitez, plus vous contribuez à faire grandir cette chaîne de générosité !",
      "title": "{{firstName}} s'est inscrit.e avec votre code d'invitation"
    },
    "savedMoney": {
      "title": {
        "borrower": "Vous avez économisé !",
        "lender": "Vous avez fait économiser !"
      },
      "message": {
        "borrower": "Vous avez économisé <strong>{{amount}} $</strong> en empruntant {{item}}.",
        "lender": "Vous avez aidé un membre à économiser <strong>{{amount}} $</strong> en prêtant {{item}}."
      }
    },
    "savedMoneyService": {
      "title": {
        "borrower": "Vous avez économisé !",
        "lender": "Vous avez fait économiser !"
      },
      "message": {
        "borrower": "Vous avez économisé <strong>{{amount}} $</strong> en demandant de l'aide pour {{item}}.",
        "lender": "Vous avez aidé un membre à économiser <strong>{{amount}} $</strong> en offrant de l'aide pour {{item}}."
      }
    },
    "savedMoneyDonation": {
      "title": {
        "borrower": "Vous avez économisé !",
        "lender": "Vous avez fait économiser !"
      },
      "message": {
        "borrower": "Vous avez économisé <strong>{{amount}} $</strong> en recevant un don pour {{item}}.",
        "lender": "Vous avez aidé un membre à économiser <strong>{{amount}} $</strong> en lui offrant {{item}}."
      }
    },
    "loanReciprocity": {
      "title": "À votre tour d’aider 🤝",
      "message": "Publiez les objets que vous utilisez peu et faites-en profiter vos voisin·es."
    },
    "trustAdded": {
      "title": "{{name}} vous fait confiance ! 🎉",
      "message": "Cette personne vous a ajouté(e) à son club de confiance. Et si vous faisiez pareil ?"
    }
  },
  "notifications-setting": {
    "chatHelp": "Recevez une notification lorsqu'un membre vous envoie un message privé, par exemple, pour vous emprunter un objet.",
    "needHelp": "Recevez une notification lorsque des membres publient de nouveaux besoins, afin de voir si vous pouvez y répondre.",
    "weeklyOffersHelp": "Recevez une notification, à chaque semaine, qui liste les nouvelles offres disponibles près de vous.",
    "conciergerieHelp": "Permettez à l'assistant intelligent de vous contacter lorsque vos objets peuvent répondre au besoin d’un membre.",
    "interestAlertsHelp": "Recevez une notification quand une nouvelle offre est publiée dans une catégorie que vous suivez."
  },
  "onboardingIntro": {
    "text": "Créez votre compte (c’est rapide, promis !) et commencez à partager avec votre communauté."
  },
  "one-channel": {
    "firstLoanPrompt": {
      "title": "Bravo pour votre premier emprunt !",
      "savedAmount": "Bravo, c’est <highlight>{{amount}}</highlight> d’économisé !",
      "description": "Le premier emprunt est offert !",
      "subscribeTitle": "Pour continuer d’emprunter",
      "subscribeDescription": "Pour continuer d’emprunter sans limite, abonnez-vous maintenant et bénéficiez d’un <strong>rabais de 25 % !</strong>",
      "subscribeDescriptionWithDeadline": "Abonnez-vous et bénéficiez <strong>d’un rabais de 25 % jusqu’au {{date}} !</strong>",
      "cta": "Passer à",
      "discountDeadlineNote": "Valide jusqu’au {{date}}.",
      "note": "Si la réservation est annulée, votre emprunt gratuit sera de nouveau disponible",
      "lending": {
        "title": "Bravo pour votre premier prêt !",
        "description": "Profitez du dédommagement sur les objets",
        "subscribeDescription": "Abonnez-vous maintenant et bénéficiez d’un <strong>rabais de 25 % !</strong>"
      }
    },
    "serviceManagement": {
      "body": {
        "late": {
          "lender": "La période prévue pour le service est dépassée. Vous pouvez contacter {{name}} pour organiser un nouveau moment afin de le réaliser. Une fois le service rendu, utilisez le bouton ci-dessous.",
          "borrower": "La période prévue pour le service est dépassée. Vous pouvez contacter {{name}} afin d’organiser un nouveau moment dès que possible. Une fois le service complété, utilisez le bouton ci-dessous."
        },
        "returned": {
          "lender": "{{name}} a indiqué que le service a été rendu. Pouvez-vous confirmer ?"
        }
      },
      "title": {
        "returned": {
          "borrower": "Vous avez reçu ce service"
        }
      }
    },
    "donationManagement": {
      "body": {
        "late": {
          "lender": "La date prévue pour le ramassage du don est passée. Vous pouvez contacter {{name}} pour organiser un nouveau moment afin de le réaliser. Une fois le ramassage effectué, utilisez le bouton ci-dessous.",
          "borrower": "La date prévue pour le ramassage du don est passée. Vous pouvez contacter {{name}} pour organiser un nouveau moment afin de le réaliser. Une fois le ramassage effectué, utilisez le bouton ci-dessous."
        },
        "returned": {
          "lender": "{{name}} a indiqué que le don a été ramassé. Pouvez-vous confirmer ?"
        }
      },
      "title": {
        "returned": {
          "borrower": "Vous avez ramassé le don"
        }
      }
    },
    "donationMessage": {
      "contentPendingIsUpdate": "La date du ramassage a été modifiée. Acceptez pour confirmer cette nouvelle date."
    },
    "notifNowInsured": "<strong>Soyez sans crainte et partagez !\n\nPartage Club peut vous dédommager jusqu'à 300 $</strong> en cas de problème sur des articles prêtés, d'une valeur de 25 $ et plus.\n\nS’il arrive quoi que ce soit, vous pouvez nous contacter ici, ou bien par courriel à <strong>info@partage.club</strong>",
    "conciergeMessage": {
      "canHelp": {
        "title": "Super ! Vous pouvez aider {{interlocutorName}} :",
        "lastMessageText": "Voulez-vous aider {{interlocutorName}} avec ce besoin",
        "proposeDates": "• Proposez des dates de prêt"
      },
      "canYouHelp": {
        "title": "Pensez-vous pouvoir l'aider ?",
        "subtitle": "Si non, j'archiverai la conversation pour vous",
        "bottomSheet": {
          "paragraph1": "Vous avez reçu ce message parce que l’assistant intelligent pense que vous pourriez avoir l’objet demandé par ce membre.",
          "paragraph2": "Tant que vous ne répondez pas “oui”, la conversation reste invisible pour l’emprunteur, alors sentez-vous à l’aise de décliner !",
          "paragraph3": {
            "bold": "désactivez l’option dans vos préférences"
          }
        },
        "lastMessageText": "Pouvez-vous aider {{interlocutorName}} avec ce besoin ?"
      },
      "matchAccepted": {
        "title": "Quelle chance ! {{interlocutorName}} souhaite vous aider",
        "lastMessageText": "{{interlocutorName}} a accepté de vous aider !",
        "proposeDates": "• Proposez des dates de prêt"
      },
      "cantHelp": {
        "subtitle": "N’hésitez pas à contacter {{interlocutorName}} si vous changez d'avis",
        "lastMessageText": "Vous ne pouvez pas aider {{interlocutorName}} avec ce besoin"
      }
    },
    "archivedConvoToast": {
      "message": "Vous pouvez la retrouver dans la section Conversations archivées."
    },
    "visibleOnlyToYou": "Visible seulement par vous",
    "transportPrompt": {
      "title": "Avez-vous besoin d’aide pour le transport ?",
      "description": "Vous pouvez contacter le service d’aide pour le transport afin d’organiser la récupération.",
      "cta": "Écrire au service d’aide"
    },
    "postSaleListingPrompt": {
      "title": "Que voulez-vous faire avec votre annonce ?",
      "description": "En reste-t-il encore à vendre ? Pensez-vous en avoir de nouveau plus tard ?"
    },
    "loanReciprocityPrompt": {
      "title": "À votre tour d’aider 🤝",
      "description": "La communauté vous permet d’emprunter plutôt que d’acheter. Publiez plusieurs objets que vous utilisez peu pour aider à votre tour.",
      "publish": "Publier mes objets"
    },
    "bonification": {
      "borrowerSubmitted": {
        "text": {
          "reviewing": "Vos suggestions ont été envoyées au prêteur pour évaluation.",
          "accepted": "Le prêteur a accepté vos suggestions. Merci pour votre aide !",
          "rejected": "Le prêteur a refusé vos suggestions. Merci d'avoir pris le temps de proposer des améliorations pour cette annonce."
        }
      },
      "lenderNudge": {
        "title": {
          "lend": "Quelqu'un veut emprunter votre objet 👋",
          "sell": "Quelqu'un veut acheter votre objet 👋",
          "give": "Quelqu'un veut recevoir votre objet 👋"
        },
        "text": "Pour que l'échange se passe encore mieux, ajoutez une vraie photo et une courte description. Ça inspire confiance et rend votre objet plus attrayant!"
      },
      "lenderReview": {
        "text1": "<strong>{{name}}</strong> a proposé des améliorations pour votre objet.",
        "text2": "👉 Vous pouvez l'examiner et décider de l'accepter, la refuser, ou la modifier"
      },
      "lenderReviewed": {
        "text": {
          "accepted": "Yahoo! Vous venez de compléter la fiche de votre objet.",
          "rejected": "Vous avez refusé les modifications suggérées pour cette annonce. Vous pouvez améliorer la fiche de votre objet par vous-même en allant dans vos offres."
        }
      },
      "borrowerPrompt": {
        "title": "🌟 Faites briller cet objet !",
        "text": "Cet objet mériterait une vraie photo ou une meilleure description. Proposez une amélioration !"
      }
    },
    "bonificationScreen": {
      "borrower": {
        "bannerTitle": "✏️ Vous êtes en mode suggestion",
        "bannerText": "La photo et la description que vous proposez seront envoyées au prêteur pour être approuvées."
      },
      "lender": {
        "bannerTitle": "✏️ Vous consultez une suggestion",
        "bannerText": "Voici la photo et/ou la description proposée par l'emprunteur. Vous pouvez l'accepter, la modifier ou la refuser.",
        "banner": "Vous consultez une suggestion d'un emprunteur.",
        "rejectConfirm": {
          "text": "Êtes-vous certain de vouloir refuser ces suggestions ?"
        }
      }
    },
    "deletedMessage": {
      "author": "Vous avez supprimé ce message"
    },
    "addToCalendar": {
      "modal": {
        "description": "Souhaitez-vous ajouter ces dates dans le calendrier de votre téléphone ?"
      }
    },
    "beaconsfieldNewLoanWarning": "Bonjour {{name}},\n\nÀ Beaconsfield, le partage se fait dans le respect, la confiance… et la bonne humeur !\nQuelques conseils pour une expérience agréable et sécuritaire :\n- Rencontrez-vous dans un lieu public si cela vous rassure (ex. : Bibliothèque, Hôtel de Ville).\n- Ne partagez que les renseignements essentiels : pour rendre possible le partage (ex : numéro de téléphone, adresse).\n\nBon partage !\n\nEt surtout, profitez-en pour tisser des liens, à votre rythme.",
    "banner": {
      "borrowerCreditExhausted": "Ce membre est en essai gratuit et ne peut plus emprunter.",
      "yourNeed": "Ce membre peut vous aider",
      "yourOffer": "Votre offre"
    },
    "levelModal": {
      "sharer1": {
        "message": "Vous avez augmenté votre impact en réalisant votre premier prêt ! Vous accédez maintenant à un niveau supérieur : <strong>Partageur</strong>."
      },
      "sharer23": {
        "message": "Vous êtes à <strong>{{numLeft}}</strong> partages du niveau ultime. Continuez un prêt à la fois !"
      },
      "sharer4": {
        "message": "<strong>Un</strong> partage de plus et vous accéderez au plus haut niveau : <strong>Super Partageur.euse</strong>.",
        "title": "Vous y êtes presque !"
      },
      "superSharer": {
        "message": "Vous avez augmenté votre impact en réalisant 5 partages ! Vous accédez maintenant au niveau ultime : <strong>Super Partageur.euse</strong> et un exemple à suivre au Partage Club.\n\nBravo! À chaque partage, vous grandissez votre impact pour un avenir plus vert.",
        "title": "Vous êtes un·e Super Partageur.euse !"
      }
    },
    "loanManagement": {
      "body": {
        "late": {
          "lender": "La période d'emprunt est dépassée. Vous pouvez contacter {{name}} afin d'organiser un moment pour qu'il.elle vous retourne l'objet. Lorsque vous aurez récupéré l'objet, utilisez le bouton ci-bas.",
          "borrower": "La période d'emprunt est dépassée. Vous pouvez contacter {{name}} afin d'organiser un moment pour retourner l'objet dès que possible. Lorsque vous aurez rendu l'objet, utilisez le bouton ci-bas."
        },
        "returned": {
          "lender": "{{name}} a indiqué avoir retourné l’objet. Pouvez-vous confirmer cela ?"
        }
      },
      "title": {
        "returned": {
          "borrower": "Vous avez retourné cet objet"
        }
      }
    },
    "saleManagement": {
      "body": {
        "ongoing": {
          "borrower": "La date prévue pour la vente est arrivée. Une fois l’objet reçu de {{name}}, confirmez la réception avec le bouton ci-dessous.",
          "lender": "La date prévue pour la vente est arrivée. Une fois l’objet remis à {{name}}, confirmez la vente avec le bouton ci-dessous."
        },
        "late": {
          "borrower": "La date prévue pour la vente est passée. Vous pouvez contacter {{name}} pour organiser la récupération. Une fois l’objet reçu, confirmez la réception avec le bouton ci-dessous.",
          "lender": "La date prévue pour la vente est passée. Vous pouvez contacter {{name}} pour organiser la récupération. Une fois l’objet remis, confirmez la vente avec le bouton ci-dessous."
        },
        "returned": {
          "borrower": "Vous avez confirmé avoir reçu l’objet. En attente de la confirmation de {{name}}.",
          "lender": "{{name}} a confirmé avoir reçu l’objet. Confirmez la vente pour la terminer."
        }
      }
    },
    "promptIntroduceYourself": "Écrivez un petit mot au membre pour vous présenter et exprimer votre intérêt.",
    "quickOffer": {
      "text": "Publiez en 10 secondes !"
    },
    "isYou": "Vous",
    "memberMenu": {
      "makeAdminModal": {
        "body": "Êtes-vous sûr de vouloir ajouter {{name}} comme administrateur de cette discussion ?"
      },
      "makeRegularModal": {
        "body": "Êtes-vous sûr de vouloir retirer les droits d'administrateur de {{name}} pour cette discussion ?"
      },
      "removeModal": {
        "body": "Êtes-vous sûr de vouloir retirer {{name}} de cette discussion ?"
      },
      "reportModal": {
        "body": "Êtes-vous sûr de vouloir signaler {{name}} ?"
      }
    },
    "silenceDurationPrompt": "Pendant combien de temps voulez-vous mettre cette conversation en sourdine ?",
    "toolbar": {
      "placeHolder": "Votre message..."
    },
    "howItWorks": {
      "assistanceQuestion": "Avez-vous besoin d'une assistance supplémentaire?",
      "borrow": {
        "step1": "<bold>Écrivez un mot</bold> pour vous présenter et <bold>exprimer votre intérêt</bold>",
        "step2": "<bold>Proposez</bold> des dates d'emprunt, <bold>attendez la confirmation</bold> de votre voisin·e puis <bold>planifiez le ramassage</bold> ensemble",
        "step3": "<bold>Récupérez l'objet</bold> chez votre voisin·e ou dans un lieu public sécuritaire. <bold>Aucun échange d'argent, c'est gratuit !</bold>",
        "step4": "<bold>Rendez-le</bold> en bon état et partagez votre expérience"
      },
      "lend": {
        "step2": "<bold>Acceptez ou proposez</bold> des dates de prêt et <bold>planifiez le ramassage</bold> ensemble",
        "step3": "<bold>Prêtez l'objet</bold> à votre voisin·e. <bold>Aucun échange d'argent, c'est gratuit !</bold>",
        "step4": "<bold>Récupérez votre objet</bold> en bon état et partagez votre expérience"
      }
    },
    "groupCreatedByYou": "Vous avez créé la discussion",
    "confirmLeave": "Êtes-vous sûr de vouloir quitter cette discussion ?",
    "confirmDelete": "Êtes-vous sûr de vouloir supprimer cette discussion ? Cette action est irréversible.",
    "changeLinkedOffer": "Changer l’offre liée",
    "unlinkOffer": "Délier l’offre"
  },
  "recommendations": {
    "your-favourites": {
      "title": "Vos favoris",
      "emptyStateTitle": "Mettez votre première offre en favori !"
    },
    "urgent-needs": {
      "title": "Aidez vos voisins !"
    },
    "match-needs-with-offers": {
      "title": "Vous pourriez aider"
    },
    "mixed-recommendations": {
      "title": "Recommandé pour vous"
    },
    "nearest-sharing-place": {
      "title": "Lieux de partage près de vous"
    }
  },
  "one-listing": {
    "trustCircle": {
      "offerLabel": "Offre de confiance",
      "requestLabel": "Besoin de confiance",
      "offerExplanation": "Vous voyez cette offre parce que {{name}} vous fait confiance",
      "requestExplanation": "Vous voyez ce besoin parce que {{name}} vous fait confiance"
    },
    "categorySection": {
      "primary": {
        "subtitle": "Sélectionnez la catégorie principale de l'objet"
      }
    },
    "confirmServiceDoneModal": {
      "text": {
        "borrower": "En confirmant que le service a été rendu, vous indiquez que {{name}} vous a bien rendu ce service.",
        "lender": "En confirmant, vous reconnaissez avoir rendu le service demandé par {{name}}."
      }
    },
    "confirmDonationDoneModal": {
      "text": {
        "borrower": "En confirmant que le don a été ramassé, vous indiquez que {{name}} vous a bien donné cet objet.",
        "lender": "En confirmant, vous reconnaissez avoir donné à {{name}} l'objet en question."
      }
    },
    "automaticMessageCard": {
      "title": "Nous contactons des membres potentiels pour vous...",
      "titleHasLender": "Vous avez trouvé un prêteur !",
      "titleWithResponses": "L’assistant contacte des prêteur·euse·s potentiel·le·s... Vous avez des réponses ! ",
      "subtitle": "Plus vous en dites, plus il sera facile pour les membres de comprendre votre offre ou votre besoin !",
      "subtitleHasLender": "<strong>{{lenderName}}</strong> a accepté de vous prêter son objet !",
      "subtitleNoCandidates": "Aucune offre trouvée. Nous attendons qu'un.e membre publie une nouvelle offre correspondant à votre besoin !",
      "subtitleDisabled": "Réactivez l'assistant pour reprendre la recherche de prêteur·euse·s potentiel·le·s.",
      "subtitleContactedAll": "En attendant leur réponse, nous restons à l’affût d’une nouvelle offre pertinente pour votre besoin",
      "subtitleWithResponses": "Des membres potentiels vous ont répondu !"
    },
    "availabilitySection": {
      "reservations": {
        "text": "Confirmer vos dates"
      },
      "quantity": {
        "text": "Indiquez la quantité et/ou l'unité"
      }
    },
    "headerSection": {
      "inventory": "Inventaire"
    },
    "confirmReturnModal": {
      "text": {
        "borrower": "En confirmant le retour de cet objet, vous signifiez que vous l'avez rendu à {{name}}.",
        "lender": "En confirmant le retour de cet objet, vous signifiez que celui-ci vous a été rendu par {{name}}."
      }
    },
    "confirmSaleModal": {
      "text": {
        "borrower": "En confirmant la réception, vous indiquez avoir reçu l’objet.",
        "lender": "En confirmant la vente, vous indiquez avoir finalisé l’échange."
      },
      "title": {
        "borrower": "Confirmer la réception ?",
        "lender": "Confirmer la vente ?"
      }
    },
    "createOfferModal": {
      "text": "D’autres membres en auront sûrement besoin. Aimeriez-vous en faire profiter d’autres membres en publiant une offre ?",
      "title": "Merci d’avoir prêté votre objet"
    },
    "beTheFirstToHelp": "Vous pouvez être la première personne à contacter ce membre.",
    "needFoundModal": {
      "step1": {
        "body": "Marquez votre annonce comme trouvé si votre besoin a été comblé."
      },
      "step2": {
        "gotoSelectLender": "Le besoin a été comblé sur Partage Club"
      },
      "step3": {
        "title": "Félicitations pour votre emprunt",
        "body": "Votre annonce a été marquée comme trouvée."
      },
      "step6": {
        "title": "Félicitations pour votre emprunt",
        "body": "Votre annonce a été marquée comme trouvée, et le prêteur aura reçu une demande de confirmation pour les dates."
      }
    },
    "subscriptionsSection": {
      "participationsDeletedToast": {
        "text": "Vous pouvez vous réinscrire à tout moment s’il reste de la place."
      }
    },
    "reportListingPrompt": "Bonjour, je souhaite signaler une annonce que je trouve inappropriée. Pourriez-vous l'examiner ?\n\nMerci."
  },
  "one-loan": {
    "contactSupportAboutIncidentPrompt": {
      "insured": "Salut {{name}} ! 😊\n\nPas de souci, les imprévus ça arrive.\n\nPour qu’on puisse vous aider, pourriez-vous nous expliquer ce qui s’est passé et, si possible, nous envoyer quelques photos de l'objet endommagé ?\n\nRassurez-vous, si un dommage survient aux objets que vous prêtez ou empruntez d'une valeur de 25 $ ou plus, <strong>nous nous engageons à vous dédommager jusqu’à 300 $ par an</strong>.\n\nMerci !",
      "uninsured": "Salut {{name}} ! 😊\n\nPas de souci, les imprévus ça arrive.\n\nPour qu’on puisse vous aider, pourriez-vous nous expliquer ce qui s’est passé et, si possible, nous envoyer quelques photos de l'objet endommagé ?\n\n<strong>On est là pour vous aider.</strong>\n\nMerci !"
    },
    "history": {
      "returned_by_you": "vous"
    },
    "serviceHistory": {
      "returned_by_you": "vous"
    },
    "donationHistory": {
      "returned_by_you": "vous"
    },
    "saleHistory": {
      "returned_by_you": "vous"
    },
    "cancelLoanModal": {
      "text": {
        "borrowing": "En confirmant l'annulation de l'emprunt, vous signifiez au prêteur que vous n'avez plus besoin de cet objet.",
        "lending": "En confirmant l'annulation du prêt, vous signifiez à l'emprunteur que ce prêt n'aura pas lieu.",
        "service": "En annulant votre demande, vous informez le membre que l'échange de service n'aura pas lieu.",
        "donation": "En annulant votre demande, vous informez le membre que le ramassage de ce don n'aura pas lieu.",
        "sale": "En annulant la vente, vous informez le membre que le ramassage n'aura pas lieu."
      }
    },
    "ratingPrompt": {
      "title": "Vous avez eu une belle expérience avec {{name}} ? Partagez-la !",
      "subtitle": "Vos commentaires aident à bâtir une communauté plus fiable"
    }
  },
  "payment": {
    "benefitsTitle": "Les avantages",
    "askForMode": {
      "title": "Choisissez un mode de paiement"
    },
    "cancellationPolicy": "Votre abonnement sera renouvelé automatiquement chaque année. Vous pouvez annuler votre abonnement jusqu’à 24 h avant la date de votre prochain paiement.",
    "expiredFreeTrial": "Votre période d'essai se terminait le {{date}}",
    "title": "Activez votre abonnement",
    "expiredPlan": "Votre abonnement se terminait le {{date}}",
    "intro": "Empruntez <highlight>sans limite</highlight> avec l’abonnement <highlight>Partage+</highlight> !",
    "loanDiscount": {
      "percentage": "-25 %",
      "price": {
        "CAD": "45 $",
        "EUR": "54 €",
        "USD": "54 USD"
      },
      "footnote": "*{{discountedPrice}} facturés annuellement, puis {{renewalPrice}} à la date de renouvellement"
    },
    "activateButton": "Activer votre abonnement",
    "modal": {
      "firstParagraph": "Merci de votre confiance. Grâce à votre abonnement, vous pouvez maintenant emprunter et prêter des objets à vos voisins sans limite.",
      "primaryButtonText": "Voir votre abonnement"
    },
    "mobileRedirect": {
      "subtitle": "L'abonnement Partage Club est en ce moment disponible uniquement sur l'app mobile.\nUne fois abonné(e), vous pourrez continuer d'utiliser le site web pour emprunter et prêter des objets."
    },
    "web": {
      "activationPending": "L’activation prend plus de temps que prévu. Votre paiement est confirmé et vous ne serez pas facturé·e de nouveau.",
      "initializationError": "Impossible de charger le paiement sécurisé. Réessayez.",
      "retryCheckout": "Réessayer le paiement",
      "genericError": "Le paiement n’a pas pu être confirmé. Vérifiez vos informations et réessayez.",
      "loading": "Chargement du paiement sécurisé…",
      "paymentConfirmed": "Paiement confirmé",
      "paymentDetails": "Mode de paiement",
      "paymentPending": "Paiement en attente",
      "paymentPendingDetails": "Votre paiement est toujours en cours de traitement. Nous activerons votre abonnement dès que Stripe l’aura confirmé.",
      "processing": "Nous activons votre abonnement. Cela prend généralement quelques secondes.",
      "removeCoupon": "Retirer le code promo",
      "taxes": "Taxes",
      "total": "Total",
      "unavailable": "Le paiement web n’est pas disponible pour cet abonnement.",
      "verifyingPayment": "Vérification de votre paiement",
      "verifyingPaymentDetails": "Nous vérifions le dernier statut du paiement auprès de Stripe.",
      "viewSubscription": "Voir votre abonnement"
    }
  },
  "paywall": {
    "firstHero": "Votre période d'essai gratuite est terminée.",
    "firstSubhero": "Vous pouvez continuer à prêter sans abonnement, mais pour emprunter, vous devez vous abonner.",
    "ctaLabel": "Abonnez-vous maintenant",
    "firstHeroBis": "Votre abonnement a expiré.",
    "redesign": {
      "cancelAnytime": "Annulez en tout temps",
      "coverageFootnote": "*La Responsabilité Partage Club vous dédommage jusqu’à 300 $ sur les objets prêtés ou empruntés.",
      "expired": {
        "subtitle": "Votre abonnement est terminé. Retrouvez tous vos avantages en un clic."
      },
      "standard": {
        "subtitle": "Débloquez l’expérience complète pour continuer d’emprunter en toute tranquillité",
        "title": "Vous êtes sur la bonne voie !"
      }
    }
  },
  "paywall2": {
    "offer": {
      "trial": "Obtenez 25 % de rabais sur l’abonnement annuel et profitez pleinement de la Responsabilité Partage Club !",
      "regular": "Voici une bonne raison de vous abonner !"
    },
    "details": {
      "trial": "Avec votre abonnement, si un dommage survient aux objets que vous prêtez ou empruntez d'une valeur de 25 $ ou plus,  <strong>nous nous engageons à vous dédommager jusqu’à 300 $ par an</strong>.\n\nCode promo : <strong>PARTAGE25</strong>",
      "regular": "Avec votre abonnement, si un dommage survient aux objets que vous prêtez ou empruntez d'une valeur de 25 $ ou plus, <strong>nous nous engageons à vous dédommager jusqu’à 300 $ par an</strong>."
    }
  },
  "personal-information": {
    "phoneFieldSubtitle": "Ne vous inquiétez pas, votre numéro ne sera jamais partagé avec un·e autre membre ou une entreprise.",
    "title": "Vos informations personnelles",
    "phoneFieldHelp": {
      "text": "Votre numéro valide votre identité, renforçant la confiance de la communauté.\n\nIl est utilisé uniquement en cas d'urgence (message manqué, courriel bloqué) pour s'assurer que chaque partage se concrétise sans accroc.\n\nIl ne sera jamais partagé avec personne d'autre."
    }
  },
  "profile-overview": {
    "deleteStatusToast": {
      "title": "Votre statut d'indisponibilité a été supprimé"
    },
    "unavailableStatusWarning": "Indisponibilité prévue du <strong>{{startDate}}</strong> au <strong>{{endDate}}</strong>"
  },
  "publicUserWelcome": {
    "instructions": "Votre compte est prêt ! Vous pourrez bientôt aider les horticulteur·trice·s et recevoir des dons de surplus.",
    "enableNotificationsPrompt": "Activez les notifications pour être averti·e dès l’ouverture !",
    "notificationsEnabled": "Les notifications sont activées. Vous serez averti·e dès l’ouverture !"
  },
  "quick-new-confirm": {
    "headerText": "En <strong>appuyant sur Publier</strong>, les objets sélectionnés seront publiés <strong>sur votre profil</strong> et d'autres personnes <strong>pourront vous les emprunter</strong>"
  },
  "quick-new-thanks": {
    "bodyText": "Vous pouvez à tout moment aller modifier vos offres dans votre centre de partages.\n\nVotre profil est complet, vous êtes prêt·e à commencer à <strong>prêter !</strong>",
    "didYouKnowTitle": "Saviez-vous que...",
    "didYouKnowBody": "Les objets avec une vraie photo ont 3x plus de chances d’être empruntés. Vous pouvez aller voir vos annonces pour les bonifier !",
    "userNowContributorText": "Vous accédez à un niveau supérieur : <strong>Contributeur</strong>. En publiant votre première offre, vous avez augmenté votre impact."
  },
  "ratings": {
    "confirmation": {
      "text1": "<strong>Vous avez recommandé {{name}} !</strong>",
      "text3": "Vous pouvez voir le nombre de recommandations des membres dans leur profil et un peu partout où l’on voit leur photo."
    },
    "notGreat": {
      "text1": "Merci pour votre retour.",
      "text2": "On est désolés que l’expérience n’ait pas été positive. 🙁 Voulez-vous qu’on s’en parle afin que l’on comprenne ce qui s’est passé ?",
      "chatPrompt": "Salut {{name}} ! 😊\n\nMerci de prendre le temps de nous partager votre expérience. Alors, qu’est-ce qui s’est passé ?"
    },
    "prompt": {
      "text2": "Partagez votre expérience pour que d’autres n’hésitent pas à faire de même :)\n\nSeules les recommandations positives seront visibles. En cas contraire, on s’en jasera."
    },
    "promptFigma": {
      "title": "Vous avez eu une belle expérience ?\nPartagez-la !",
      "subtitle": "Vos commentaires aident à bâtir une communauté plus fiable"
    },
    "ratingPrompt": {
      "text": "Votre avis a été publié ! Merci d’avoir pris le temps de partager votre expérience."
    },
    "rated": {
      "recommended": "Vous avez recommandé {{name}}",
      "notRecommended": "Vous n'avez pas recommandé {{name}}"
    },
    "newRating": {
      "intro": "Votre évaluation honnête contribue à bâtir une communauté plus fiable. Notez chaque aspect de 1 à 5.",
      "tapToRate": "Touchez un chiffre pour évaluer",
      "commentHelp": "Visible uniquement par l'équipe Partage Club. Utilisez ce champ pour signaler un problème ou ajouter du contexte.",
      "errorMessage": "Vos évaluations n'ont pas pu être enregistrées. Réessayez.",
      "notReadyMessage": "Cet échange doit être entièrement terminé avant de laisser une évaluation. Si vous avez retourné l'objet, attendez la confirmation de l'autre personne.",
      "figmaOverallQuestion": {
        "lender": "Votre expérience de prêt s'est-elle bien passée ?",
        "borrower": "Votre expérience d'emprunt s'est-elle bien passée ?"
      },
      "figmaAddDetailsTitle": "Ajoutez des détails",
      "figmaPublicCommentHint": "Votre évaluation sera visible publiquement",
      "thanks": {
        "title": "Merci pour votre évaluation !",
        "subtitle": "Vous contribuez à bâtir une communauté plus <strong>fiable</strong>",
        "negativeSubtitle": "Nous sommes désolés que l'expérience n'ait pas été positive. Nous examinerons votre évaluation en détail."
      },
      "reciprocity": {
        "title": "À votre tour de partager",
        "description": "Votre emprunt s’est bien passé ? Publiez les objets que vous utilisez peu et aidez la communauté à votre tour.",
        "publish": "Publier mes objets"
      }
    }
  },
  "reset-password": {
    "passwordFieldLabel": "Votre nouveau mot de passe",
    "passwordFieldPlaceholder": "Choisissez un nouveau mot de passe",
    "details": "Un code de confirmation vous a été envoyé par courriel. Entrez-le ci-dessous, puis choisissez un nouveau mot de passe."
  },
  "presentPartageClub": {
    "community": {
      "footerText": "Profitez <strong>pleinement</strong> de la vie, sans vous limiter à ce que vous possédez."
    },
    "accessMore": {
      "headerText": "Sur Partage Club, vous accédez à une <strong>abondance d'objets</strong>.",
      "footerText": "Équipement de sport, outils, jeux pour enfants, etc. : ici, vous trouvez <strong>vraiment tout.</strong>"
    },
    "offerMore": {
      "headerText": "Sur Partage Club, votre <strong>générosité</strong> fait une vraie <strong>différence</strong>.",
      "footerText": "Faites <strong>profiter</strong> les autres de vos objets trop peu utilisés. Ça fait du bien."
    }
  },
  "presentCommunity": {
    "newFlow": {
      "yearlyPrice": "{{annualPrice}}/année ({{monthlyPrice}}/mois). Annulez en tout temps",
      "unlimitedLendingDescription": "Publiez des offres et prêtez vos objets à vos voisin·e·s autant de fois que vous le souhaitez",
      "oneFreeBorrowDescription": "Empruntez votre premier objet à vos voisin·e·s gratuitement",
      "coverageFootnote": "*La Responsabilité Partage Club vous dédommage jusqu'à 300 $ sur les objets prêtés ou empruntés.",
      "free": {
        "title": "Démarrez gratuitement !",
        "subtitle": "Découvrez les joies du partage sans frais."
      },
      "sponsored": {
        "title": "Votre abonnement\nest offert !",
        "subtitle": "Profitez de l’expérience complète grâce à"
      },
      "upsell": {
        "subtitle": "Abonnez-vous pour activer le dédommagement sur vos partages."
      },
      "success": {
        "subtitle": "Votre abonnement est actif et vous avez accès à l’expérience complète",
        "yourSubscription": "Votre abonnement",
        "currentPlan": {
          "monthly": "Vous êtes présentement sur un abonnement mensuel.",
          "yearly": "Vous êtes présentement sur un abonnement annuel.",
          "no": "Votre abonnement est actif."
        },
        "billingNote": {
          "monthly": "*Vous serez facturé {{price}} / mois à la date de renouvellement. Annulez jusqu’à 24 h avant la date de votre prochain paiement.",
          "yearly": "*Vous serez facturé {{price}} / année à la date de renouvellement. Annulez jusqu’à 24 h avant la date de votre prochain paiement."
        },
        "cancelAnytime": "Annulez à tout moment",
        "cancellationDescription": "Vous pouvez annuler votre abonnement jusqu’à 24 h avant la date de votre prochain paiement. Votre abonnement sera renouvelé chaque année."
      }
    },
    "congratulation": {
      "text1": "{{name}}, vous êtes officiellement partageur.euse.",
      "text2": "Vous avez obtenu un abonnement gratuit",
      "text3": "Grâce à {{name}}, votre abonnement est gratuit. 🎉\n\n",
      "text4": "Profitez-en pour partager de façon illimitée avec la communauté.",
      "freeTrial": {
        "text1": "Vous avez maintenant \naccès à la communauté.",
        "text4": "Ensuite, si vous voulez continuer à emprunter, choisissez votre abonnement :",
        "text5": "Nous ne prélèvons rien sans votre accord."
      }
    },
    "responsibility": {
      "footerText": "Grâce à votre abonnement, si un objet d’une valeur de 25 $ ou plus est endommagé pendant un prêt, on vous dédommage <strong>jusqu’à 300 $ par an.</strong>"
    },
    "trust": {
      "footerText": "On privilégie les <strong>échanges dans les lieux publics</strong> et on utilise un système de recommandations pour vous garder en <strong>sécurité</strong>."
    },
    "free": {
      "footerText": "Et si vous êtes du genre à aider souvent, on peut même vous reconnaître comme <strong>ambassadeur·rice</strong> et vous offrir votre abonnement."
    }
  },
  "quickInterest": {
    "headerTitle": "Centres d'intérêt",
    "title": "Quels sont vos centres d'intérêt ?",
    "subtitle": "Personnalisez vos recommandations et soyez notifié des nouvelles offres.",
    "instruction": "Sélectionnez un ou plusieurs intérêts :",
    "nothingSelectedError": {
      "text": "Vous devez sélectionner au minimum un centre d'intérêt pour continuer.",
      "title": "Sélectionnez 1+ centre(s) d'intérêt"
    }
  },
  "interests": {
    "nothingSelectedError": {
      "title": "Sélectionnez un équipement",
      "text": "Vous devez sélectionner au minimum un équipement pour continuer."
    },
    "explain": {
      "subtitle": {
        "borrower": "Dites-nous ce que vous aimez et ce que vous rêvez d’essayer pour que l’on vous propose des objets faits pour vous.",
        "lender": "Montrez aux autres membres ce que vous avez à offrir. \n\nBesoin d’inspiration ?\nParlez-nous un peu de vous et nous vous suggérerons des idées d'objets à prêter.",
        "both": "Dites-nous ce que vous aimez et ce que vous rêvez d’essayer pour que l’on vous propose des objets faits pour vous."
      }
    },
    "chooseTag": {
      "title": {
        "lender": "Choisissez les catégories d'objets que vous possédez",
        "borrower": "Quels sont vos centres d’intérêt ?",
        "both": "Quels sont vos centres d’intérêt ?"
      },
      "subtitle": {
        "borrower": "Vous aimez le camping ou les jeux de société ? Ajoutez vos intérêts à votre profil et laissez-nous vous montrer ce qui pourrait vous plaire.",
        "lender": "Ça nous aidera à vous proposer des idées d'objets à prêter.",
        "both": "Vous aimez le camping ou les jeux de société ? Ajoutez vos intérêts à votre profil et laissez-nous vous montrer ce qui pourrait vous plaire."
      }
    },
    "chooseListing": {
      "subtitle": {
        "borrower": "Nous avons repéré des objets qui correspondent à vos intérêts ! Ajoutez-les dans vos favoris.",
        "lender": "Nous avons trouvé des objets souvent demandés que vous pourriez prêter.",
        "both": "Nous avons repéré des objets qui correspondent à vos intérêts ! Ajoutez-les dans vos favoris."
      },
      "aggregateTitle": {
        "borrower": "Selon les catégories choisies, voici des objets qui pourraient vous intéresser.",
        "lender": "Selon les catégories choisies, nous avons trouvé des objets souvent demandés que vous pourriez prêter.",
        "both": "Selon les catégories choisies, voici des objets qui pourraient vous intéresser."
      }
    }
  },
  "streak": {
    "objectiveDetails": "L’objectif du mois est déterminé en fonction du nombre de voisin·e·s partageur·euse·s autour de vous et de la maturité de votre quartier.",
    "seriesDetails": "Pour garder la flamme du partage active, vous et vos voisin·e·s devez atteindre l’objectif de partages indiqué pour le mois.",
    "contributeDailyTitle": "Contribuez quotidiennement pour maintenir votre flamme!",
    "tips": {
      "publishRequest": {
        "title": "Publiez un besoin pour emprunter",
        "description": "Vous avez besoin d'un objet? Les membres autour de vous essaieront de vous aider."
      },
      "browseCatalog": {
        "title": "Explorez le catalogue",
        "description": "Explorez le catalogue et proposez des dates d'emprunt."
      },
      "helpNeighbours": {
        "title": "Essayez d'aider vos voisin·e·s",
        "description": "Explorez les besoins des membres autour de vous, vous pouvez masquer ceux auxquels vous ne pouvez pas répondre."
      },
      "publishOffer": {
        "title": "Publier une offre pour prêter",
        "description": "Publiez un objet spécifique ou choisissez parmi les objets suggérés."
      }
    },
    "neighbourhoodFirstShare": "Dans votre quartier, <strong>{{percent}}% de vos voisin·e·s</strong> ont fait leur premier partage <strong>en moins d'une semaine</strong>.",
    "empty": {
      "title": "Démarrez votre série et contribuez maintenant!"
    },
    "contributions": {
      "add_avatar": {
        "title": "Ajoutez une photo",
        "description": "Une photo de profil rassure vos voisin·e·s et vous rend reconnaissable dans le quartier."
      },
      "add_bio": {
        "title": "Ajoutez une bio",
        "description": "Présentez-vous en quelques mots pour donner envie aux autres membres de vous prêter et de vous emprunter des objets."
      },
      "publish_offer": {
        "description": "Publiez un objet spécifique, ou choisissez parmi les objets suggérés; les offres ont déjà été préparées par nos voisins!"
      },
      "publish_request": {
        "description": "Vous avez besoin d'un objet? Publiez un besoin, les membres autour de vous essaieront d'y répondre."
      },
      "dismiss_request": {
        "title": "Essayez d'aider vos voisins",
        "description": "Explorez les besoins des membres autour de vous, vous pouvez masquer ceux auxquels vous ne pouvez pas répondre."
      },
      "send_message": {
        "title": "Envoyez un message",
        "description": "Brisez la glace ! Écrivez à un·e voisin·e pour proposer votre aide ou en savoir plus sur une annonce."
      },
      "add_favourite": {
        "description": "Explorez le catalogue et sauvegardez les offres pertinentes pour y revenir plus tard"
      }
    }
  },
  "superPartageur": {
    "subtitle": {
      "isSuper": "Vous êtes\n<strong>Super Partageur.euse</strong>"
    }
  },
  "superPartageurDetails": {
    "description": "C’est quoi un·e Super Partageur.euse ?\nUn membre partageur qui s’engage de façon constante envers la communauté.\n\nBonne nouvelle : tout le monde peut le devenir ! Les critères sont simples et évalués automatiquement chaque jour.\n\nPour obtenir votre badge, il vous suffit de remplir ces 3 conditions :",
    "requirements": {
      "trustPoints": {
        "description": "Obtenez <strong>{{requiredValue}} recommandations positives (👍)</strong> de membres après un partage, que ce soit un prêt ou un emprunt."
      },
      "lastActiveDays": {
        "description": "Vous devez avoir ouvert l'application <strong>au moins une fois dans les {{requiredValue}} derniers jours</strong>."
      },
      "responseRate": {
        "description": "Ne jouez pas au fantôme ! 👻\n\nMaintenez un taux de réponse aux messages des membres <strong>supérieur à {{requiredValue}} %</strong>."
      }
    }
  },
  "superPartageurNotification": {
    "title": {
      "lostSuper": "Votre badge a disparu ?\nC’est normal."
    },
    "description": {
      "lostSuper": "Nous avons mis à jour les critères du badge Super Partageur.euse. Il ne suffit plus de partager : votre badge évolue désormais en fonction de votre activité, de vos recommandations et de votre taux de réponse.",
      "keptSuper": "Vous restez <strong>Super Partageur.euse</strong>, même avec les nouveaux critères.",
      "isNowSuper": "Vous êtes maintenant\n<strong>Super Partageur.euse</strong>."
    },
    "progress": {
      "one": "<strong>Super, vous êtes sur la bonne voie.</strong>",
      "two": "<strong>Super, vous y êtes presque !</strong>"
    }
  },
  "unavailable": {
    "clearHint": "Retirez cette plage si vous êtes de nouveau disponible.",
    "selectRangeHint": "Sélectionnez une date de début puis une date de fin (touchez le même jour une deuxième fois pour un seul jour).",
    "singleDayRangeHint": "Un jour sélectionné : vous serez indisponible pour toute la journée."
  },
  "onboarding": {
    "button": {
      "modifyInterests": "Modifier vos intérêts"
    }
  },
  "account-deletion": {
    "disclaimer": "La suppression de votre compte est définitive.",
    "subtitle": "Votre profil, vos offres, vos besoins, vos données ainsi que vos conversations avec les membres seront définitivement supprimés."
  },
  "loginAsPrompt": {
    "message": "Voulez-vous être connecté en tant que {{userName}} ?"
  },
  "all-channels": {
    "sharedListing": "{{sender}} a partagé une annonce",
    "empty": {
      "secondLine": {
        "recent": "Vous n'avez pas échangé avec un membre récemment."
      }
    },
    "footer": {
      "text": "Les vieilles conversations sont archivées automatiquement. Cliquez sur l'onglet Archivés pour les consulter."
    }
  },
  "api-errors": {
    "Municipal activation code already active": "Ce code est déjà actif sur votre compte.",
    "Social sign-in failed": "La connexion avec ce service a échoué. Réessayez ou connectez-vous avec votre courriel et votre mot de passe. Si vous n’avez pas de mot de passe ou si vous l’avez oublié, utilisez l’option de réinitialisation du mot de passe dans le formulaire de connexion.",
    "The last admin cannot leave or be removed before another member is promoted": {
      "": "Vous devez nommer un autre administrateur avant de pouvoir quitter cette discussion."
    },
    "An account already exists for this email address": {
      " Please use the log in form": {
        "": "Un compte existe déjà avec cette adresse courriel. Utilisez le formulaire de connexion."
      }
    },
    "Can't delete listing that has accepted loan": {
      "": {
        "offer": "Vous ne pouvez pas supprimer une offre dont le prêt est présentement en cours ou en retard. Vous devez soit annuler ce prêt, soit confirmer le retour de cet objet.",
        "request": "Vous ne pouvez pas supprimer un besoin dont l'emprunt est présentement en cours ou en retard. Le retour doit d'abord être confirmé par le propriétaire."
      }
    },
    "Date is required": "Veuillez choisir une date",
    "Please complete your profile before creating a listing": {
      "": "Veuillez compléter votre profil avant de créer une annonce."
    },
    "Please enter a valid activation code": {
      "": "Veuillez entrer un code d'invitation valide."
    },
    "You already created a listing for this item in this category": "Vous avez déjà publié une offre avec ce nom dans cette catégorie.",
    "You are not authorized to use this code": "Vous n'êtes pas autorisé à utiliser ce code.",
    "You need a valid license to post a need": {
      "": "Vous devez avoir une licence valide pour publier un besoin."
    },
    "An account already exists for this email address. Please use the log in form.": "Un compte existe déjà avec cette adresse courriel. Utilisez le formulaire de connexion."
  },
  "app_update": {
    "question": "Voulez-vous mettre à jour?"
  },
  "calendar": {
    "disabled": "Vous ne pouvez pas modifier les dates d’un besoin dont l’emprunt est présentement en cours ou en retard."
  },
  "calendar-settings": {
    "calendarModal": {
      "text": "Pour nous permettre d'ajouter des événements dans le calendrier de votre téléphone, veuillez accéder aux réglages de votre appareil et autoriser l'accès complet au calendrier."
    }
  },
  "chooseUserType": {
    "alreadyHaveAccount": "Vous avez déjà un compte ?",
    "loggedIn": "Vous êtes connecté !",
    "loggedInRedirect": "Vous serez redirigé automatiquement.",
    "instructionsLoggedIn": "Choisissez votre profil ci-dessous pour finaliser votre compte :",
    "instructions": "Ou choisissez votre profil ci-dessous :"
  },
  "collection": {
    "itemHasListingsIStillNeedThisPrompt": "Si les offres ci-haut ne vous conviennent pas, vous pouvez toujours publier un besoin avec ce bouton.",
    "nobodyOfferedYet": "⭐️ Soyez le premier à l'offrir !",
    "postNeedPrompt": {
      "text": "Les membres peuvent vous aider à trouver ce que vous cherchez."
    },
    "subscriptionSuccess": "Vous êtes abonné·e. Vous recevrez une notification quand un membre publie une offre pour cet objet.",
    "unsubscriptionSuccess": "Vous êtes désabonné. Vous ne recevrez plus de notification pour cet objet."
  },
  "help": {
    "assistanceQuestion": "Avez-vous besoin d'une assistance supplémentaire?",
    "guestCta": {
      "text": "Rejoignez votre voisinage et découvrez tout ce que vous pouvez emprunter près de chez vous."
    },
    "compensation": {
      "text": "Vous êtes dédommagé·e sur les objets prêtés et empruntés"
    },
    "borrower": {
      "steps": {
        "catalog": {
          "text": "Cherchez un objet dans le catalogue ou créez un besoin visible par la Municipalité"
        },
        "meeting": {
          "text": "Proposez et confirmez des dates d'emprunt et de ramassage avec votre voisin·e"
        },
        "pickup": {
          "title": "Récupérez l'équipement et utilisez-le!",
          "text": "Organisez une rencontre avec la Municipalité pour récupérer l’équipement."
        },
        "return": {
          "title": "Rendez l'objet",
          "text": "Ramenez l'objet en bon état à son·sa propriétaire et partagez votre expérience"
        }
      }
    },
    "lender": {
      "steps": {
        "photo": {
          "title": "Prenez un équipement en photo",
          "text": "Prenez quelques clichés qui mettent en valeur votre équipement"
        },
        "publish": {
          "title": "Publiez une offre",
          "text": "Ajoutez des détails d'usage sur votre équipement et publiez votre offre. Si vous manquez de temps, choisissez des annonces pré-faites par nos soins pour des équipements souvent demandés."
        },
        "share": {
          "text": "Rencontrez votre voisin·e à votre domicile ou dans un lieu public sécuritaire pour lui donner l'objet. <strong>Aucun échange d'argent, c'est gratuit !</strong>"
        },
        "return": {
          "text": "Reprenez l'objet à la fin du prêt et partagez votre expérience. <strong>Moins de 1%</strong> des objets empruntés sont endommagés. Et souvent, ils reviennent encore plus propres. C'est magique."
        }
      }
    }
  },
  "credentials": {
    "activationCodeFieldPlaceholder": "Entrez le code qui vous a été partagé"
  },
  "email-verification": {
    "subtitle": "Un courriel a été envoyé contenant un code de sécurité. Veuillez entrer ce code avant de pouvoir continuer."
  },
  "forgot-password": {
    "subtitle": "Saisissez votre adresse courriel ci-dessous et nous vous enverrons un courriel contenant les instructions pour créer un nouveau mot de passe.",
    "title": "Récupérer votre mot de passe"
  },
  "free-sub": {
    "headerText": "Vous avez publié votre première offre.",
    "headerTextFiveOffers": "Vous avez publié 5 offres !",
    "headerTextNotYet": "Vous contribuez à faire grandir le catalogue du <strong>Partage Club</strong> !",
    "headerTextTutorial": "Vous maîtrisez à présent l'art de partager des objets.",
    "spreadTheLoveText": "Parlez-en à vos voisin.e.s pour qu’eux.elles aussi puissent profiter de l’offre spéciale !",
    "subHeaderTextTutorial": "Merci d'avoir publié un objet. Nous sommes ravis de vous annoncer que votre abonnement annuel gratuit est maintenant activé !",
    "subscriptionNotYetActivatedText": "<strong>Continuez à publier des offres pour gagner votre abonnement !</strong>",
    "userNowContributorText": "Vous accédez à un niveau supérieur : <strong>Contributeur</strong>. En publiant votre première offre, vous avez augmenté votre impact."
  },
  "grouped-listing": {
    "concierge": {
      "description": "Publiez un besoin dans votre communauté. On contacte les prêteurs pour vous.",
      "pausedDescription": "Votre besoin reste visible dans votre communauté. Reprenez quand vous voulez.",
      "activeDescription": "Votre besoin est visible dans votre communauté. On contacte les prêteurs pour vous.",
      "waitingDescription": "Votre besoin est visible dans votre communauté. Consultez les réponses dans votre besoin.",
      "foundDescription": "Ouvrez votre besoin pour échanger avec le.la prêteur.se."
    },
    "headerSection": {
      "numOffers": "Nombre de prêteurs : {{numOffers}}"
    },
    "listHeader": "Contactez directement un.e prêteur.se :",
    "listHeaderLegacy": "Choisissez un.e prêteur.se :"
  },
  "image-picker": {
    "fileTooLarge": {
      "text": "Veuillez choisir un fichier de moins de {{max}} Mo."
    }
  },
  "impact": {
    "levels": {
      "0": {
        "description-completed": "Rejoint Partage Club"
      },
      "1": {
        "description": "Publiez une offre"
      }
    }
  },
  "loanDatesPicker": {
    "informationTextAsBorrower": "Proposez des dates au prêteur pour effectuer la réservation et suivre l’objet jusqu’à son retour.",
    "informationTextAsLender": "Proposez des dates à l’emprunteur pour effectuer la réservation et suivre votre objet jusqu’à son retour.",
    "informationTextAsService": "Proposez une date au membre pour ce service afin fixer la réservation.",
    "informationTextAsDonation": "Proposez une date de ramassage pour récupérer ce don",
    "informationTextAsSell": "Proposez une date de ramassage au vendeur pour effectuer la réservation.",
    "informationTextForExistingLoanAsBorrower": "Proposez de nouvelles dates au prêteur. Les dates acceptées précédemment seront toujours effectives jusqu'à l'acceptation de ces nouvelles dates.",
    "informationTextForExistingLoanAsLender": "Proposez de nouvelles dates à l’emprunteur. Les dates acceptées précédemment seront toujours effectives jusqu'à l'acceptation de ces nouvelles dates.",
    "informationTextForExistingLoanAsService": "Proposez une nouvelle date au membre pour ce service. La date acceptée précédemment sera toujours effective jusqu'à l'acceptation de cette nouvelle date.",
    "informationTextForExistingLoanAsDonation": "Proposez une nouvelle date au membre pour le ramassage de ce don. La date acceptée précédemment sera toujours effective jusqu'à l'acceptation de cette nouvelle date.",
    "informationTextForExistingLoanAsSell": "Proposez une nouvelle date de ramassage au vendeur. La date acceptée précédemment sera toujours effective jusqu'à l'acceptation de cette nouvelle date.",
    "plannedSalePeriodReminder": "Rappel : la période définie lors de la création de l’offre est du {{start}} au {{end}}.",
    "primaryButtonTextAsLenderSingleDate": "Proposer cette date",
    "promptIntroduceYourself": "N'oubliez pas d'écrire un message au membre pour vous présenter et lui exprimer votre intérêt !"
  },
  "loanFee": {
    "modals": {
      "amount": {
        "text": "<strong>Combien charger ?</strong>\n\nVoici quelques repères pour estimer un frais de partage :\n\n  • Petit prêt (outils, accessoires, etc)\n<strong>5 % de la valeur marchande</strong>\n\n  • Prêt nécessitant du montage/démontage\n<strong>5 à 10 % selon l’effort requis</strong>\n\n  • Prêt avec transport ou déplacement\n<strong>Ajouter un montant fixe (ex. 10 $)</strong>\n\n  • Prêt impliquant du temps ou de la coordination\n<strong>Estimer selon le temps investi (ex. 10 $/h)</strong>\n\nCes montants sont à titre indicatif, adaptez-les selon votre jugement et les particularités de chaque prêt."
      }
    }
  },
  "my-clubs": {
    "help": {
      "neighbourhoods": {
        "paragraph2": "L’école de votre enfant, votre chalet, etc."
      }
    }
  },
  "my-impact-financial": {
    "empty": {
      "borrowing": {
        "firstLine": "Le montant que vous économisez en empruntant s’affichera ici.",
        "secondLine": "Commencez à emprunter et voyez combien d’argent vous économisez !"
      },
      "lending": {
        "firstLine": "Le montant que les autres membres économisent en empruntant vos objets s’affichera ici.",
        "secondLine": "Partagez vos objets et voyez combien d'argent vous permettez aux membres d'économiser !"
      }
    },
    "emptyByTransaction": {
      "lend": {
        "borrowing": {
          "firstLine": "Le montant que vous économisez en empruntant s’affichera ici.",
          "secondLine": "Commencez à emprunter et voyez combien d’argent vous économisez !"
        },
        "lending": {
          "firstLine": "Le montant que les autres membres économisent en empruntant vos objets s’affichera ici.",
          "secondLine": "Partagez vos objets et voyez combien d'argent vous permettez aux membres d'économiser !"
        }
      },
      "sell": {
        "borrowing": {
          "firstLine": "Le montant de vos achats s’affichera ici.",
          "secondLine": "Commencez à acheter et suivez la valeur de vos achats !"
        },
        "lending": {
          "firstLine": "Le montant de vos ventes s’affichera ici.",
          "secondLine": "Commencez à vendre et suivez la valeur de vos ventes !"
        }
      },
      "give": {
        "borrowing": {
          "firstLine": "La valeur des objets que vous recevez s’affichera ici.",
          "secondLine": "Récupérez des objets et suivez la valeur de vos dons reçus !"
        },
        "lending": {
          "firstLine": "La valeur des objets que vous donnez s’affichera ici.",
          "secondLine": "Donnez des objets et suivez la valeur de vos dons !"
        }
      }
    }
  },
  "my-listings": {
    "emptyState": {
      "all": "Vos offres s'afficheront ici",
      "lend": "Vos offres à prêter s'afficheront ici",
      "sell": "Vos offres à vendre s'afficheront ici",
      "give": "Vos offres à donner s'afficheront ici"
    },
    "hideAlert": {
      "message": "Ces objets ne seront plus visibles par les autres, mais vous pourrez les restaurer plus tard ici."
    },
    "deleteAlert": {
      "message": "Êtes-vous sûr de vouloir supprimer ces objets ? Cette action est irréversible."
    },
    "duplicateToast": {
      "text": "Les copies ont été ajoutées à vos offres."
    }
  },
  "travel-distance": {
    "noteBelowMap": "Ajustez votre zone de recherche en la déplaçant sur la carte.",
    "text": "La distance de recherche s'applique uniquement aux annonces de votre Club de quartier."
  },
  "my-profile": {
    "offers": {
      "empty": "Vous n'avez publié aucune offre"
    },
    "requests": {
      "empty": "Vous n'avez publié aucun besoin"
    }
  },
  "notification-explainer": {
    "context": {
      "chat": {
        "subtitle": "Soyez alerté dès que cette personne vous répond en reçevant une notification.",
        "title": "Aimeriez-vous savoir lorsque {{name}} vous répond ?"
      },
      "listing": {
        "subtitle": "Soyez alerté dès qu'une personne vous contacte en reçevant une notification.",
        "title": "Aimeriez-vous savoir lorsque quelqu'un vous contacte ?"
      }
    }
  },
  "notification-warn": {
    "subtitle": "Soyez alerté dès qu’une personne vous écrit pour emprunter vos objets ou répondre à votre besoin.",
    "title": "Activez les notifications pour rester informé·e !"
  },
  "offerAvailability": {
    "titleDonation": "Date limite",
    "titleSell": "Date de la vente",
    "conflictsInformationText": "Certains objets sont <strong>déjà prêtés</strong> pour ces dates. Vous pouvez continuer la réservation, mais contactez l'emprunteur ensuite pour résoudre ce(s) conflit(s).",
    "informationText": "Réservez vos objets pour les rendre indisponibles à l'emprunt pendant les jours sélectionnés.",
    "informationTextDonation": "Vous pouvez choisir une date limite pour indiquer que vous aimeriez que le ramassage soit effectué avant cette date.",
    "refrainPopup": {
      "text": {
        "lender": {
          "before": "N’oubliez pas de réserver vos dates de festival et planifier vos journées de montage et démontage lors de votre réservation.",
          "after": "N’oubliez pas de réserver vos dates de festival et planifier vos journées de montage et démontage."
        },
        "borrower": "N’oubliez pas de planifier vos journées de montage et démontage lors de votre emprunt."
      },
      "subtext": {
        "lender": {
          "before": "Réservez le nombre de jours complets où le ou les objets ne seront pas disponibles.",
          "after": "Réservez le nombre de jours complets où l’objet n’est pas disponible."
        },
        "borrower": "Proposez le nombre de jours complets où l’objet sera emprunté."
      }
    }
  },
  "offers": {
    "empty": {
      "firstLine": "Toutes les offres que vous publierez au sein de la communauté se retrouveront ici.",
      "secondLine": "Vous n'avez pas encore publié d'offre."
    }
  },
  "quick-new-choose": {
    "headerTextHalloween": "C'est bientôt l'<strong>Halloween</strong>, des membres recherchent ces déguisements. Les avez-vous ?",
    "nothingSelectedError": {
      "text": "Vous devez sélectionner au minimum un équipement pour continuer.",
      "title": "Sélectionnez un équipement"
    }
  },
  "settingsPrompt": {
    "camera": {
      "text": "Pour nous permettre d'accéder à la caméra, veuillez accéder aux réglages de votre appareil et activer la permission à cet effet."
    },
    "notification": {
      "text": "Pour nous permettre de vous envoyer des notifications, veuillez accéder aux réglages de votre appareil et activer les notifications."
    }
  },
  "borrowerNext": {
    "title": "Que souhaitez-vous faire maintenant ?",
    "searchLabel": "Cherchez un objet spécifique"
  },
  "lenderNext": {
    "title": "Que souhaitez-vous faire maintenant ?"
  },
  "ambassador": {
    "subtitle": {
      "isAmbassador": "Vous êtes\n<strong>Ambassadeur·rice</strong>"
    },
    "advantages": {
      "titleIsAmbassador": "Vos avantages",
      "advantage1": {
        "body": "Des personnes de votre quartier, qui, comme vous, veulent créer une résilience locale"
      },
      "advantage2": {
        "body": "Votre abonnement est gratuit et nous pouvons vous en fournir lors de l'organisation d'événements"
      },
      "advantage3": {
        "body": "Donnez votre avis sur les futures priorités et projets de Partage Club et du programme ambassadeur"
      },
      "advantage6": {
        "body": "Profitez de promotions offertes par les lieux de partage proches de chez vous : réductions, cadeaux et plus encore..."
      }
    },
    "mission": {
      "description": "<strong>Être Ambassadeur·rice...</strong>\nC'est faire rayonner la mission du partage à votre échelle, de la façon qui vous ressemble. Chacun·e s'implique selon son temps, ses envies et ses forces.",
      "concrete1": "Faire connaître Partage Club autour de vous",
      "concrete2": "Garder des objets en pension chez vous",
      "concrete3": "Organiser des activités et moments de partage",
      "concrete4": "Participer à la création de contenu",
      "concrete5": "Proposer vos propres idées..."
    }
  },
  "trialPromo": {
    "title": "Contribuez à faire grandir le catalogue du Partage Club et gagnez votre abonnement !",
    "details": "Contribuez à faire grandir le catalogue du <strong>Partage Club</strong> ! Publiez 5 objets et gagnez votre <strong>abonnement annuel</strong> ! 🥳"
  },
  "tutorial": {
    "guardian": {
      "step1": {
        "text": "Laissez la garde de votre objet à votre emprunteur·euse pour la durée que vous souhaitez en le·la désignant gardien·ne. Iel pourra l’utiliser et le prêter à son tour."
      }
    },
    "firstConversation": {
      "step1": {
        "title": "Présentez-vous",
        "text": "Écrivez un petit mot au membre pour vous présenter et exprimer votre intérêt."
      }
    },
    "chatIntro": {
      "step1": {
        "title": "👋 Présentez-vous",
        "text": "Écrivez un petit mot au membre pour vous présenter et exprimer votre intérêt."
      },
      "step2": {
        "text": "Cliquez ici pour accéder au calendrier et choisir une date de début et de fin pour l'emprunt. Le prêteur pourra ensuite l'accepter ou la refuser."
      },
      "step2AltRequest": {
        "text": "Cliquez ici pour accéder au calendrier et choisir une date de début et de fin pour le prêt. L'emprunteur pourra ensuite l'accepter ou la refuser."
      }
    },
    "multipleOffers": {
      "step1": {
        "title": "Publier votre premier objet",
        "text": "En offrant vos objets, vous encouragez même vos voisin.e.s les plus timides à demander."
      }
    },
    "publishOffers": {
      "step1": {
        "text": "Ici, la <strong>confiance</strong> règne. Tous les membres s'engagent à respecter les règles d'or.\n\nEn cas de problème, <strong>l'équipe du Partage Club</strong> est à votre service en tout temps. (1/5)"
      },
      "step3": {
        "title": "2 façons d’offrir vos objets en partage",
        "text": "Publiez un objet à la fois ou plusieurs objets en même temps, en un clic. <strong>Sélectionnez l’offre multiple</strong> pour continuer. (3/5)"
      },
      "step4": {
        "title": "Votre annonce est publiée",
        "text": "Vous pouvez modifier vos annonces à tout moment. (4/5)"
      },
      "step4AltPlural": {
        "title": "Vos annonces sont publiées",
        "text": "Vous pouvez modifier vos annonces à tout moment. (4/5)"
      },
      "step5": {
        "text": "Vous pouvez à tout moment publier une offre individuelle en prenant une photo de votre objet. (5/5)"
      },
      "stepFinal": {
        "text": "Vous maîtrisez à présent l'art de partager des objets.\n\nVous avez augmenté votre impact en publiant votre première offre. Vous accédez désormais au niveau supérieur : Contributeur."
      }
    },
    "conciergerie": {
      "step1": {
        "text": "Lorsque l’assistant contacte un membre et que celui-ci répond, la discussion est marquée d’un symbole pour vous aider à la repérer"
      }
    },
    "homeExplore": {
      "step1": {
        "title": "Cherchez un équipement",
        "text": "Utilisez la barre de recherche et les filtres pour trouver un objet et faire une demande d’emprunt."
      },
      "step2": {
        "title": "Publiez une offre ou un besoin",
        "text": "Utilisez ce bouton rapide pour publier une offre de prêt pour un objet spécifique ou choisissez parmi les offres déjà faites par nos soins. Vous pouvez également demander l’aide d’autres municipalités en publiant un besoin."
      },
      "step3": {
        "text": "Cliquez ici pour recevoir de l'aide sur le processus de partage."
      }
    },
    "contactMember": {
      "step1": {
        "title": "On y est presque! Contactez-le",
        "text": "Prenez le temps de regarder les détails de l'offre. Si elle correspond à vos attentes, cliquez ici pour entrer en contact avec le prêteur."
      }
    }
  },
  "tutorialModal": {
    "publishOffers": {
      "text": "<strong>Comment offrir vos objets en partage</strong>"
    }
  },
  "posts": {
    "newPost": {
      "title": "Partagez votre expérience",
      "intro": "Aidez votre communauté en partageant un court message sur cet échange. Vous pourrez le modifier plus tard.",
      "publicHint": "Ce message apparaîtra dans le fil de votre communauté. Ce n'est pas une évaluation privée.",
      "storyHint": "Partagez ce qui s'est passé, ce que vous avez aimé ou un détail utile pour les autres.",
      "textPlaceholder": "Parlez-nous de votre expérience..."
    },
    "editPost": {
      "intro": "Vous pouvez modifier le message que vous avez partagé sur cet échange. N'oubliez pas que ce message est public et visible par votre communauté.",
      "publicHint": "Ce message apparaîtra dans le fil de votre communauté. Ce n'est pas une évaluation privée.",
      "storyHint": "Partagez ce qui s'est passé, ce que vous avez aimé ou un détail utile pour les autres.",
      "textPlaceholder": "Parlez-nous de votre expérience..."
    },
    "feed": {
      "endOfFeed": {
        "status": "Vous avez tout vu !",
        "title": "À vous de raconter la suite.",
        "description": "Un objet emprunté, une belle rencontre…\nPartagez votre histoire avec le voisinage.",
        "action": "Raconter mon histoire",
        "actionHint": "Choisissez un emprunt passé pour raconter votre histoire."
      },
      "reportPostPrompt": "Bonjour, je souhaite signaler un post de {{name}} au sujet de {{item}} parce qu'il me semble inapproprié. Pourriez-vous l'examiner ?\n\nMerci."
    },
    "comments": {
      "empty": "Aucun commentaire pour l'instant. Soyez le premier à commenter !"
    },
    "storyComposer": {
      "publicHint": "Partagé publiquement avec votre communauté.",
      "textPlaceholder": "Grâce à cet emprunt, j’ai…",
      "composeTitle": "Faites revivre ce moment.",
      "composeHint": "Un projet, une découverte, un petit geste. Racontez-le à votre façon.",
      "storyTitle": "Votre histoire",
      "addPhotos": "Ajoutez ce moment en images",
      "photoHint": "Facultatif · jusqu’à 10 photos",
      "discardMessage": "Si vous choisissez un autre emprunt, le texte et les photos de ce brouillon seront perdus."
    }
  },
  "new-group-chat": {
    "minimumMembersError": "Ajoutez au moins 2 membres pour créer une discussion de groupe.",
    "choosePhotoHint": "Choisissez une image pour personnaliser la discussion de groupe"
  },
  "add-chat-members": {
    "forbiddenBody": "Vous devez être administrateur du groupe pour ajouter des membres à cette discussion."
  },
  "offer-hub": {
    "title": "Créer des offres",
    "heading": "Vous l’avez? Partagez-le.",
    "explanation": "Glissez à droite ou touchez « J’ai ça » pour publier tout de suite.",
    "accept": "J'ai ça",
    "reject": "Je n’ai pas",
    "visibility": "Partagé avec {{destinations}}",
    "noDestinations": "aucune destination choisie",
    "editVisibility": "Changer où je partage",
    "doneEditing": "Terminé",
    "selectDestination": "Choisissez au moins un quartier ou un club pour publier vos offres.",
    "loading": "On prépare vos suggestions…",
    "retryLoading": "Réessayer de charger",
    "storageError": "Certains choix n’ont pas pu être enregistrés sur cet appareil. Gardez l’application ouverte et réessayez pour les conserver.",
    "retry": "Réessayer",
    "loadError": "Impossible de charger vos suggestions. Réessayez dans un instant.",
    "progress": "{{current}} / {{total}}",
    "encouragement": "Quelques choix, plus de partage.",
    "completeTitle": "Bien joué!",
    "completeDescription": "Chaque choix compte. Merci d’avoir pris le temps!",
    "caughtUp": "Tout exploré!",
    "caughtUpDescription": "Votre prochain partage se cache chez vous.",
    "more_one": "Essayer {{count}} autre objet",
    "more_other": "Essayer {{count}} autres objets",
    "challenge": "3 objets à faire circuler.",
    "challengeDescription": "Les objets du quotidien peuvent faire des heureux. Un petit tour dans…",
    "viewOffers": "Voir mes offres",
    "failedTitle": "Ces choix sont à vérifier",
    "otherWays": "Une autre idée en tête?",
    "single": "Créer une offre",
    "photos": "Quelques photos",
    "donate": "Donner un objet",
    "edit": "Modifier",
    "lastItem": "Le dernier, vous y êtes presque!",
    "roundProgress": "Objets passés en revue",
    "acceptHint": "Publiez une offre dans les quartiers et clubs choisis.",
    "published_one": "offre publiée",
    "published_other": "offres publiées",
    "pending_one": "choix en cours",
    "pending_other": "choix en cours",
    "failed_one": "à vérifier",
    "failed_other": "à vérifier",
    "pendingDescription": "Vos choix s’enregistrent. Vous pouvez continuer à explorer.",
    "singleDescription": "Ajouter un objet de votre choix.",
    "photosDescription": "Créer plusieurs offres.",
    "eyebrow": "OFFRES EXPRESS",
    "challengeEyebrow": "PETITE CHASSE AUX TRÉSORS",
    "huntCupboard": "Cuisine",
    "huntLivingRoom": "Salon",
    "huntGarage": "Garage",
    "startHunt": "Trouver mes 3 trésors",
    "huntPhotos": "On vous aide à transformer les photos en offres.",
    "huntSingle": "Un objet pour commencer. Les autres suivront.",
    "remaining_one": "Le dernier!",
    "remaining_other": "Encore {{count}}",
    "chooseRoom": "On commence par quelle pièce?",
    "roomPrompt": "Vous avez peut-être…",
    "kitchenIdeas": "Un gaufrier, un moule à gâteau, un mélangeur…",
    "livingIdeas": "Un jeu de société, un projecteur, un tapis de yoga…",
    "garageIdeas": "Une perceuse, un escabeau, une pompe à vélo…",
    "photographFinds": "Photographier mes trouvailles",
    "quickSignal_one": "Publiez 1 objet en {{seconds}} sec !",
    "quickSignal_other": "Publiez {{count}} objets en {{seconds}} sec !",
    "quickTitle": "Publier des objets",
    "quickCardStart": "Démarrer",
    "whyPublish": "Pourquoi publier des offres ?",
    "benefitReciprocity": "Ça donne envie de vous rendre la pareille",
    "benefitTrust": "Les autres vous feront plus confiance",
    "benefitKarma": "C’est bon pour le karma",
    "startTitle": "Avez-vous ces objets ?",
    "startDescription": "Passez au travers d’une liste d’objets prêts à publier instantanément",
    "resumeTitle": "Vous êtes proche du but !",
    "resumeDescription": "Terminez votre liste en cours",
    "listComplete": "Vous avez fini cette liste !",
    "lifetimeStats": "Vos statistiques depuis la création de votre compte",
    "swipeTutorial": {
      "0": {
        "title": "Prêt à publier\nrapidement ?",
        "description": "Passez au travers d’une liste d’objets prêts à publier instantanément"
      },
      "1": {
        "title": "Vous avez l'objet? Balayez à droite",
        "description": "Vous pourrez modifier les détails plus tard"
      },
      "2": {
        "title": "Vous n'avez pas l'objet? Balayez à gauche",
        "description": "Vous ne verrez plus l’objet dans la liste"
      },
      "3": {
        "title": "Vous êtes paré !",
        "description": "Vous avez toutes les bases pour démarrer votre première liste"
      }
    },
    "tutorial": {
      "steps": {
        "suggestions": {
          "title": "Offres rapides suggérées",
          "description": "Passez au travers d’une liste d’offres pré-existantes à publier instantanément"
        },
        "photos": {
          "title": "Publier en lot",
          "description": "Prenez plusieurs objets en photo, on génère les descriptions pour vous et vous n’avez qu’à les réviser avant de publier les offres"
        },
        "manual": {
          "title": "Saisie manuelle",
          "description": "Créez votre offre pour un seul objet spécifique"
        }
      }
    },
    "storyPickHint": "Derrière chaque objet emprunté, il y a un moment à raconter. Retrouvez un emprunt passé pour commencer votre histoire.",
    "storyMemories": "Vos emprunts passés",
    "storyLoading": "On retrouve vos souvenirs de partage…",
    "storyEmpty": "Votre prochaine histoire reste à vivre. Après un emprunt terminé, vous pourrez raconter ce moment ici."
  },
  "featurePresentations": {
    "guardian": {
      "title": "Vous pouvez maintenant envoyer vos objets en pension !",
      "description": "Si vous prêtez de façon <strong>récurrente</strong> à un·e même emprunteur·euse, il est possible de lui laisser la <strong>garde</strong> de votre objet aussi longtemps que vous le souhaitez.\n\nIl·elle pourra également prêter votre objet à d’autres membres si vous êtes d’accord.\n\nRetrouvez l’option dans le détail d’un prêt."
    }
  },
  "guardian": {
    "confirmAssign": "Vous êtes sur le point de désigner {{name}} gardien·ne de votre objet.\n\nVotre offre passera en statut « En pension », il vous suffit de contacter {{name}} depuis les détails de l’offre pour arranger le retour de l’objet quand vous le souhaitez.",
    "confirmReclaim": "Vous confirmez avoir récupéré votre objet ? Cette action mettra fin à sa pension. Le·la gardien·ne ne pourra plus le prêter.",
    "lastActive": "Actif·ve il y a {{ago}}"
  },
  "support-profile": {
    "welcomeDescription": "L’équipe {{team}} est disponible pour vous accompagner dans vos échanges et l’utilisation de l’application."
  }
}
